// src/logo/logo_small.svg
var logo_small_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="-76.238 -66.766 1164.039 1164.039" width="32" height="32" role="img" aria-label="MAAT icon">%0A  <path fill="%23FF6A74" d="M382.365 234.683C318.676 240.814 254.405 269.198 224.406 324.895C223.362 305.113 222.318 285.33 221.274 265.548C220.893 258.327 220.23 250.428 215.195 245.237C207.799 237.612 195.291 239.711 185.007 242.373C143.99 252.992 102.972 263.612 61.954 274.231C46.517 278.228 26.943 289.411 32.472 304.368C35.294 312.001 43.705 315.688 49.754 321.131C63.299 333.319 64.479 353.787 64.67 372.006C65.713 471.664 65.991 571.33 65.505 670.993C65.395 693.365 64.655 717.538 50.927 735.203C44.273 743.764 34.842 750.333 30.31 760.183C12.545 798.794 82.137 789.426 98.933 789.569C139.166 789.911 179.399 790.253 219.632 790.595C231.088 790.693 243.145 790.643 253.127 785.021C263.109 779.398 269.769 766.142 264.21 756.125C259.318 747.312 247.9 744.877 240.037 738.571C227.037 728.145 225.654 709.214 225.33 692.554C224.308 640.048 223.287 587.542 222.265 535.036C221.468 494.09 220.77 452.369 232.466 413.12C244.162 373.871 270.464 336.772 308.879 322.576C328.171 315.448 350.19 314.607 369.118 322.652C393.984 333.221 410.736 357.748 418.492 383.629C426.249 409.509 426.275 436.985 426.237 464.003C426.137 536.356 426.037 608.709 425.937 681.062C425.91 700.72 425.027 722.568 411.193 736.534C400.923 746.902 383.407 753.879 383.62 768.47C383.861 785.01 405.969 790.076 422.511 790.061C479.187 790.007 535.862 789.953 592.537 789.899C610.099 789.883 634.05 783.337 632.262 765.866C630.722 750.814 611.027 746.366 600.444 735.553C590.198 725.084 589.138 708.962 588.705 694.319C586.574 622.129 585.129 549.876 587.504 477.694C588.363 451.592 589.819 425.018 598.956 400.553C613.402 361.876 647.641 331.202 687.668 321.08C702.997 317.203 719.495 316.254 734.426 321.457C756.442 329.128 772.259 349.341 780.244 371.245C788.23 393.149 789.49 416.85 790.415 440.145C793.578 519.747 793.766 599.467 790.98 679.082C790.343 697.298 789.154 716.694 778.419 731.423C772.449 739.614 763.94 745.694 758.008 753.912C752.076 762.13 749.308 774.245 755.781 782.044C761.511 788.948 771.71 789.533 780.682 789.569C838.358 789.801 896.035 790.034 953.711 790.266C963.796 790.307 974.326 790.246 983.302 785.65C992.279 781.055 999.019 770.392 995.714 760.864C991.746 749.428 977.165 746.435 968.016 738.508C956.132 728.21 954.528 710.657 953.889 694.945C951.151 627.585 950.509 560.14 951.967 492.74C952.891 450.024 954.613 406.805 945.602 365.04C936.591 323.275 915.366 282.318 879.557 259.011C853.599 242.115 822.092 235.739 791.167 234.036C748.96 231.713 705.801 237.687 667.481 255.531C629.161 273.375 595.978 303.666 578.549 342.176C565.628 302.292 535.588 268.276 497.608 250.521C467.754 236.566 434.072 232.578 401.131 233.514C394.904 233.691 388.637 234.079 382.365 234.683"/>%0A</svg>';

// src/logo/logo_large.svg
var logo_large_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="14.422 224.936 609.005 193.077" width="202" height="64" role="img" aria-label="maat">%0A  <path fill="%23FF6A74" d="M114.116 271.868C100.165 273.211 86.086 279.429 79.515 291.629C79.286 287.296 79.058 282.962 78.829 278.629C78.745 277.047 78.6 275.317 77.497 274.18C75.877 272.51 73.137 272.969 70.885 273.553C61.9 275.879 52.915 278.205 43.93 280.531C40.548 281.406 36.26 283.856 37.472 287.133C38.09 288.805 39.932 289.612 41.257 290.805C44.224 293.474 44.483 297.958 44.525 301.949C44.753 323.779 44.814 345.611 44.707 367.442C44.683 372.343 44.521 377.638 41.514 381.507C40.057 383.383 37.991 384.822 36.998 386.979C33.107 395.437 48.351 393.385 52.03 393.416C60.843 393.491 69.656 393.566 78.469 393.641C80.979 393.663 83.62 393.652 85.806 392.42C87.993 391.188 89.452 388.285 88.234 386.09C87.162 384.16 84.661 383.626 82.939 382.245C80.091 379.961 79.788 375.815 79.717 372.165C79.494 360.664 79.27 349.162 79.046 337.661C78.871 328.691 78.719 319.552 81.281 310.955C83.843 302.357 89.604 294.231 98.019 291.121C102.245 289.56 107.068 289.376 111.214 291.138C116.661 293.453 120.331 298.825 122.03 304.495C123.729 310.164 123.734 316.182 123.726 322.101C123.704 337.95 123.682 353.799 123.66 369.648C123.654 373.954 123.461 378.74 120.431 381.799C118.181 384.07 114.344 385.598 114.391 388.795C114.444 392.418 119.287 393.528 122.91 393.524C135.325 393.512 147.74 393.501 160.154 393.489C164.001 393.485 169.248 392.051 168.856 388.224C168.519 384.927 164.205 383.953 161.886 381.584C159.642 379.291 159.41 375.759 159.315 372.552C158.848 356.738 158.532 340.911 159.052 325.1C159.24 319.382 159.559 313.561 161.56 308.202C164.725 299.73 172.225 293.011 180.993 290.793C184.351 289.944 187.965 289.736 191.235 290.876C196.058 292.556 199.523 296.984 201.272 301.782C203.021 306.58 203.297 311.772 203.5 316.875C204.193 334.312 204.234 351.774 203.624 369.214C203.484 373.204 203.224 377.453 200.872 380.679C199.564 382.474 197.7 383.805 196.401 385.606C195.102 387.406 194.495 390.06 195.913 391.768C197.168 393.28 199.402 393.408 201.368 393.416C214.002 393.467 226.636 393.518 239.27 393.569C241.479 393.578 243.786 393.565 245.752 392.558C247.718 391.551 249.195 389.216 248.471 387.129C247.601 384.623 244.408 383.968 242.403 382.231C239.8 379.976 239.449 376.131 239.309 372.689C238.709 357.934 238.569 343.16 238.888 328.396C239.09 319.039 239.468 309.571 237.494 300.423C235.52 291.274 230.87 282.303 223.026 277.197C217.34 273.496 210.439 272.099 203.664 271.726C194.419 271.217 184.965 272.526 176.571 276.435C168.177 280.344 160.908 286.979 157.09 295.415C154.26 286.678 147.68 279.227 139.36 275.337C132.821 272.28 125.443 271.407 118.227 271.612C116.863 271.651 115.49 271.736 114.116 271.868 M463.48 354.254C463.135 360.039 461.8 365.922 458.084 370.382C451.161 378.7 436.899 381.853 429.035 373.08C423.19 366.562 422.78 356.897 427.809 349.761C429.993 346.658 435.52 342.898 438.908 341.027C446.307 336.944 454.467 333.89 462.26 330.645C463.365 330.278 463.42 333.168 463.48 334.126C463.847 339.992 463.836 348.382 463.48 354.254M511.667 382.29C510.72 381.075 508.881 382.263 507.442 382.821C504.897 383.812 501.925 382.263 500.426 379.981C498.932 377.693 498.571 374.869 498.324 372.15C496.65 353.608 498.401 334.93 497.668 316.323C497.295 306.899 496.152 297.092 491.002 289.184C486.301 281.96 478.606 277.03 470.381 274.447C462.314 271.913 453.733 271.469 445.278 271.825C445.119 271.831 444.955 271.836 444.791 271.847C434.141 272.329 423.245 274.107 414.111 279.602C404.978 285.102 397.896 294.931 398.066 305.591C398.131 309.69 399.374 313.965 402.373 316.766C405.016 319.235 408.688 320.28 412.273 320.751C415.266 321.145 418.582 321.112 420.969 319.251C424.236 316.706 424.433 311.967 425.21 307.895C426.863 299.21 432.592 291.39 440.38 287.198C442.93 285.819 445.76 284.806 448.66 284.861C455.014 284.981 460.322 290.312 462.468 296.299C464.613 302.28 464.268 308.831 463.896 315.179C463.819 316.471 463.704 317.872 462.845 318.841C462.112 319.667 460.99 320.001 459.928 320.302C451.084 322.803 442.241 325.309 433.397 327.81C422.578 330.869 411.441 334.093 402.646 341.103C387.81 352.935 385.375 377.239 401.836 388.961C407.779 393.197 415.08 395.195 422.348 395.879C438.317 397.389 456.054 391.769 464.306 378.016C467.125 385.508 473.336 391.654 480.856 394.401C488.381 397.149 497.087 396.443 504.071 392.53C507.338 390.696 510.326 388.064 511.677 384.578C511.968 383.834 512.154 382.92 511.667 382.29 M335.951 354.517C335.601 360.302 334.271 366.179 330.555 370.645C323.632 378.963 309.37 382.116 301.501 373.337C295.661 366.825 295.246 357.155 300.275 350.019C302.458 346.921 307.986 343.161 311.373 341.29C318.778 337.202 326.932 334.153 334.725 330.903C335.831 330.536 335.891 333.431 335.951 334.389C336.318 340.255 336.301 348.645 335.951 354.517M383.935 381.864C382.178 381.442 380.619 383.04 378.862 383.467C376.667 383.993 374.38 382.548 373.231 380.605C372.081 378.662 371.819 376.336 371.633 374.087C370.067 355.557 371.457 336.906 371.009 318.316C370.795 309.685 370.117 300.787 366.204 293.092C361.043 282.935 350.661 276.094 339.623 273.281C332.755 271.525 325.635 271.18 318.543 271.683C314.241 271.99 309.95 272.608 305.726 273.424C297.166 275.065 288.536 277.583 281.564 282.815C274.586 288.046 269.502 296.447 270.17 305.143C270.838 313.834 278.488 322.004 287.195 321.484C289.154 321.369 291.136 320.822 292.712 319.651C296.647 316.739 297.024 311.152 298.223 306.402C300.182 298.631 305.332 291.719 312.216 287.614C314.892 286.022 317.902 284.818 321.016 284.867C327.337 284.971 332.602 290.301 334.676 296.272C336.75 302.242 336.318 308.749 335.863 315.054C335.77 316.291 335.645 317.621 334.824 318.545C334.249 319.202 333.412 319.552 332.602 319.87C316.222 326.327 298.124 328.106 282.39 336.009C276.836 338.794 271.533 342.439 268.03 347.567C258.365 361.719 262.47 382.553 277.394 391.003C283.917 394.697 291.53 396.136 299.022 396.235C313.825 396.427 329.685 390.615 337.226 377.874C340.017 385.383 346.212 391.556 353.732 394.325C361.251 397.094 369.963 396.41 376.963 392.503C380.903 390.297 384.603 386.33 383.935 381.864 M563.526 288.25L563.086 289.227C563.459 310.814 562.507 332.537 563.396 354.071C563.676 360.857 562.986 368.207 569.475 372.348C571.049 373.352 576.035 373.355 577.991 373.206C584.113 372.741 592.339 367.698 596.125 363.009C597.399 361.43 599.89 355.643 602.768 358.622C604.742 360.665 602.832 367.237 602.003 369.733C599.201 378.176 591.123 386.582 583.412 390.799C570.1 398.078 546.73 399.328 535.749 387.357C528.84 379.825 528.059 369.812 527.664 360.04L527.619 289.015L527.11 288.39L510.966 288.097C509.641 287.255 509.066 286.483 508.748 284.92C509.251 281.72 507.201 278.437 510.89 276.717C513.994 275.27 519.154 274.451 522.65 273.177C532.394 269.624 540.74 262.574 546.789 254.263C548.209 252.313 551.517 245.842 552.921 244.809C553.178 244.62 554.981 243.867 555.324 243.812C556.309 243.655 560.61 243.621 561.543 243.794C562.38 243.949 562.951 245.68 563.108 246.478L562.816 274.659C565.127 275.225 567.276 274.674 569.464 274.645C576.874 274.548 584.312 274.623 591.718 274.807C592.155 275.207 592.733 275.595 592.852 276.222C593.014 277.081 593.159 280.024 593.159 281.03C593.159 281.912 592.849 285.976 592.59 286.425C592.045 287.371 590.38 288.25 589.315 288.25L563.526 288.25"/>%0A</svg>';

// src/logo/wordmark.ts
var BRAND_CORAL = "#FF6A74";
var WORDMARK = {
  viewBox: "14.422 224.936 609.005 193.077",
  d: "M114.116 271.868C100.165 273.211 86.086 279.429 79.515 291.629C79.286 287.296 79.058 282.962 78.829 278.629C78.745 277.047 78.6 275.317 77.497 274.18C75.877 272.51 73.137 272.969 70.885 273.553C61.9 275.879 52.915 278.205 43.93 280.531C40.548 281.406 36.26 283.856 37.472 287.133C38.09 288.805 39.932 289.612 41.257 290.805C44.224 293.474 44.483 297.958 44.525 301.949C44.753 323.779 44.814 345.611 44.707 367.442C44.683 372.343 44.521 377.638 41.514 381.507C40.057 383.383 37.991 384.822 36.998 386.979C33.107 395.437 48.351 393.385 52.03 393.416C60.843 393.491 69.656 393.566 78.469 393.641C80.979 393.663 83.62 393.652 85.806 392.42C87.993 391.188 89.452 388.285 88.234 386.09C87.162 384.16 84.661 383.626 82.939 382.245C80.091 379.961 79.788 375.815 79.717 372.165C79.494 360.664 79.27 349.162 79.046 337.661C78.871 328.691 78.719 319.552 81.281 310.955C83.843 302.357 89.604 294.231 98.019 291.121C102.245 289.56 107.068 289.376 111.214 291.138C116.661 293.453 120.331 298.825 122.03 304.495C123.729 310.164 123.734 316.182 123.726 322.101C123.704 337.95 123.682 353.799 123.66 369.648C123.654 373.954 123.461 378.74 120.431 381.799C118.181 384.07 114.344 385.598 114.391 388.795C114.444 392.418 119.287 393.528 122.91 393.524C135.325 393.512 147.74 393.501 160.154 393.489C164.001 393.485 169.248 392.051 168.856 388.224C168.519 384.927 164.205 383.953 161.886 381.584C159.642 379.291 159.41 375.759 159.315 372.552C158.848 356.738 158.532 340.911 159.052 325.1C159.24 319.382 159.559 313.561 161.56 308.202C164.725 299.73 172.225 293.011 180.993 290.793C184.351 289.944 187.965 289.736 191.235 290.876C196.058 292.556 199.523 296.984 201.272 301.782C203.021 306.58 203.297 311.772 203.5 316.875C204.193 334.312 204.234 351.774 203.624 369.214C203.484 373.204 203.224 377.453 200.872 380.679C199.564 382.474 197.7 383.805 196.401 385.606C195.102 387.406 194.495 390.06 195.913 391.768C197.168 393.28 199.402 393.408 201.368 393.416C214.002 393.467 226.636 393.518 239.27 393.569C241.479 393.578 243.786 393.565 245.752 392.558C247.718 391.551 249.195 389.216 248.471 387.129C247.601 384.623 244.408 383.968 242.403 382.231C239.8 379.976 239.449 376.131 239.309 372.689C238.709 357.934 238.569 343.16 238.888 328.396C239.09 319.039 239.468 309.571 237.494 300.423C235.52 291.274 230.87 282.303 223.026 277.197C217.34 273.496 210.439 272.099 203.664 271.726C194.419 271.217 184.965 272.526 176.571 276.435C168.177 280.344 160.908 286.979 157.09 295.415C154.26 286.678 147.68 279.227 139.36 275.337C132.821 272.28 125.443 271.407 118.227 271.612C116.863 271.651 115.49 271.736 114.116 271.868 M463.48 354.254C463.135 360.039 461.8 365.922 458.084 370.382C451.161 378.7 436.899 381.853 429.035 373.08C423.19 366.562 422.78 356.897 427.809 349.761C429.993 346.658 435.52 342.898 438.908 341.027C446.307 336.944 454.467 333.89 462.26 330.645C463.365 330.278 463.42 333.168 463.48 334.126C463.847 339.992 463.836 348.382 463.48 354.254M511.667 382.29C510.72 381.075 508.881 382.263 507.442 382.821C504.897 383.812 501.925 382.263 500.426 379.981C498.932 377.693 498.571 374.869 498.324 372.15C496.65 353.608 498.401 334.93 497.668 316.323C497.295 306.899 496.152 297.092 491.002 289.184C486.301 281.96 478.606 277.03 470.381 274.447C462.314 271.913 453.733 271.469 445.278 271.825C445.119 271.831 444.955 271.836 444.791 271.847C434.141 272.329 423.245 274.107 414.111 279.602C404.978 285.102 397.896 294.931 398.066 305.591C398.131 309.69 399.374 313.965 402.373 316.766C405.016 319.235 408.688 320.28 412.273 320.751C415.266 321.145 418.582 321.112 420.969 319.251C424.236 316.706 424.433 311.967 425.21 307.895C426.863 299.21 432.592 291.39 440.38 287.198C442.93 285.819 445.76 284.806 448.66 284.861C455.014 284.981 460.322 290.312 462.468 296.299C464.613 302.28 464.268 308.831 463.896 315.179C463.819 316.471 463.704 317.872 462.845 318.841C462.112 319.667 460.99 320.001 459.928 320.302C451.084 322.803 442.241 325.309 433.397 327.81C422.578 330.869 411.441 334.093 402.646 341.103C387.81 352.935 385.375 377.239 401.836 388.961C407.779 393.197 415.08 395.195 422.348 395.879C438.317 397.389 456.054 391.769 464.306 378.016C467.125 385.508 473.336 391.654 480.856 394.401C488.381 397.149 497.087 396.443 504.071 392.53C507.338 390.696 510.326 388.064 511.677 384.578C511.968 383.834 512.154 382.92 511.667 382.29 M335.951 354.517C335.601 360.302 334.271 366.179 330.555 370.645C323.632 378.963 309.37 382.116 301.501 373.337C295.661 366.825 295.246 357.155 300.275 350.019C302.458 346.921 307.986 343.161 311.373 341.29C318.778 337.202 326.932 334.153 334.725 330.903C335.831 330.536 335.891 333.431 335.951 334.389C336.318 340.255 336.301 348.645 335.951 354.517M383.935 381.864C382.178 381.442 380.619 383.04 378.862 383.467C376.667 383.993 374.38 382.548 373.231 380.605C372.081 378.662 371.819 376.336 371.633 374.087C370.067 355.557 371.457 336.906 371.009 318.316C370.795 309.685 370.117 300.787 366.204 293.092C361.043 282.935 350.661 276.094 339.623 273.281C332.755 271.525 325.635 271.18 318.543 271.683C314.241 271.99 309.95 272.608 305.726 273.424C297.166 275.065 288.536 277.583 281.564 282.815C274.586 288.046 269.502 296.447 270.17 305.143C270.838 313.834 278.488 322.004 287.195 321.484C289.154 321.369 291.136 320.822 292.712 319.651C296.647 316.739 297.024 311.152 298.223 306.402C300.182 298.631 305.332 291.719 312.216 287.614C314.892 286.022 317.902 284.818 321.016 284.867C327.337 284.971 332.602 290.301 334.676 296.272C336.75 302.242 336.318 308.749 335.863 315.054C335.77 316.291 335.645 317.621 334.824 318.545C334.249 319.202 333.412 319.552 332.602 319.87C316.222 326.327 298.124 328.106 282.39 336.009C276.836 338.794 271.533 342.439 268.03 347.567C258.365 361.719 262.47 382.553 277.394 391.003C283.917 394.697 291.53 396.136 299.022 396.235C313.825 396.427 329.685 390.615 337.226 377.874C340.017 385.383 346.212 391.556 353.732 394.325C361.251 397.094 369.963 396.41 376.963 392.503C380.903 390.297 384.603 386.33 383.935 381.864 M563.526 288.25L563.086 289.227C563.459 310.814 562.507 332.537 563.396 354.071C563.676 360.857 562.986 368.207 569.475 372.348C571.049 373.352 576.035 373.355 577.991 373.206C584.113 372.741 592.339 367.698 596.125 363.009C597.399 361.43 599.89 355.643 602.768 358.622C604.742 360.665 602.832 367.237 602.003 369.733C599.201 378.176 591.123 386.582 583.412 390.799C570.1 398.078 546.73 399.328 535.749 387.357C528.84 379.825 528.059 369.812 527.664 360.04L527.619 289.015L527.11 288.39L510.966 288.097C509.641 287.255 509.066 286.483 508.748 284.92C509.251 281.72 507.201 278.437 510.89 276.717C513.994 275.27 519.154 274.451 522.65 273.177C532.394 269.624 540.74 262.574 546.789 254.263C548.209 252.313 551.517 245.842 552.921 244.809C553.178 244.62 554.981 243.867 555.324 243.812C556.309 243.655 560.61 243.621 561.543 243.794C562.38 243.949 562.951 245.68 563.108 246.478L562.816 274.659C565.127 275.225 567.276 274.674 569.464 274.645C576.874 274.548 584.312 274.623 591.718 274.807C592.155 275.207 592.733 275.595 592.852 276.222C593.014 277.081 593.159 280.024 593.159 281.03C593.159 281.912 592.849 285.976 592.59 286.425C592.045 287.371 590.38 288.25 589.315 288.25L563.526 288.25"
};

// src/logo/index.ts
var logoSmall = logo_small_default;
var logoLarge = logo_large_default;

// src/illustrations/palette.ts
var ILL_PALETTE = {
  /** The single accent. One element per scene, never two. */
  accent: "#C5142A",
  /** Blob container fill. */
  arch: "#F4EDE3",
  /** Punched-out notches — matches the container so they read as holes. */
  cut: "#F4EDE3",
  white: "#FFFFFF",
  /** Lightest subject fill. */
  n2: "#EFE7DB",
  /** Mid fill — bars, most text-lines. */
  n3: "#DED2C2",
  /** Darkest fill — pots, saucers. */
  n4: "#C0B2A0",
  /** The ground ellipse every subject sits on. */
  ground: "#E6DACA"
};
var ILL_VIEW_BOX = { width: 180, height: 160 };
var ILL_BLOB_D = "M90 18c33 0 50 20 50 50 0 34-17 66-50 66s-50-32-50-66c0-30 17-50 50-50Z";

// src/illustrations/primitives.ts
var frame = (plain = false) => [
  { kind: "path", d: ILL_BLOB_D, fill: ILL_PALETTE.arch, opacity: plain ? 0.6 : 1 },
  { kind: "ellipse", cx: 90, cy: 133, rx: 52, ry: 5, fill: ILL_PALETTE.ground, opacity: plain ? 0.5 : 1 }
];
var bar = (x, y, w, fill, h = 4) => ({
  kind: "rect",
  x,
  y,
  width: w,
  height: h,
  rx: h / 2,
  fill
});
var star = (cx, cy, fill, s = 6) => ({
  kind: "path",
  transform: `translate(${cx} ${cy}) scale(${s})`,
  fill,
  d: "M0-1 .29-.32 1-.31.45.13.62.81 0 .42-.62.81-.45.13-1-.31-.29-.32Z"
});
var plant = (x, base = 130, flip = false) => {
  const s = flip ? -1 : 1;
  const o = [x, base - 12];
  return [
    {
      kind: "g",
      anim: "sway",
      origin: o,
      children: [
        { kind: "rect", x: x - 1.3, y: base - 26, width: 2.6, height: 14, fill: ILL_PALETTE.n4 },
        {
          kind: "g",
          anim: "leaf1",
          origin: o,
          children: [
            {
              kind: "ellipse",
              cx: x - 7 * s,
              cy: base - 27,
              rx: 4.4,
              ry: 9,
              transform: `rotate(${-26 * s} ${x - 7 * s} ${base - 27})`,
              fill: ILL_PALETTE.n4
            }
          ]
        },
        {
          kind: "g",
          anim: "leaf2",
          origin: o,
          children: [
            {
              kind: "ellipse",
              cx: x + 7 * s,
              cy: base - 25,
              rx: 4.4,
              ry: 8.4,
              transform: `rotate(${26 * s} ${x + 7 * s} ${base - 25})`,
              fill: ILL_PALETTE.n3
            }
          ]
        },
        {
          kind: "g",
          anim: "leaf3",
          origin: o,
          children: [
            {
              kind: "ellipse",
              cx: x + 0.5 * s,
              cy: base - 34,
              rx: 4.2,
              ry: 9.6,
              fill: ILL_PALETTE.n4
            }
          ]
        }
      ]
    },
    { kind: "path", d: `M${x - 7.5} ${base - 12}h15l-2 12h-11Z`, fill: ILL_PALETTE.n3 },
    { kind: "rect", x: x - 9, y: base - 14.5, width: 18, height: 4.5, rx: 2, fill: ILL_PALETTE.n4 }
  ];
};
var cup = (x, base = 130) => {
  const wisp = (dx, dy) => `M${x + dx} ${base - 24 - dy}c-3.4-4.4 3.4-6.6 0-11`;
  return [
    {
      kind: "g",
      fill: "none",
      stroke: ILL_PALETTE.n4,
      strokeWidth: 1.8,
      strokeLinecap: "round",
      origin: [x, base - 24],
      children: [
        // Steam rests at opacity 0, so a frozen frame shows no steam. Each wisp
        // names its OWN origin — the group's is inert, because `transform-origin`
        // only applies to the element carrying the transform. Without these the
        // scaleX pivots at the user-space origin and the plumes drift sideways,
        // clean out of the cup at the page set's 1.7x.
        { kind: "path", anim: "w1", d: wisp(-5, 0), opacity: 0, origin: [x, base - 24] },
        { kind: "path", anim: "w2", d: wisp(1, 3), opacity: 0, origin: [x, base - 24] },
        { kind: "path", anim: "w3", d: wisp(6, 1), opacity: 0, origin: [x, base - 24] }
      ]
    },
    {
      kind: "path",
      d: `M${x + 11} ${base - 17}c7 0 7 9 0 9`,
      fill: "none",
      stroke: ILL_PALETTE.n4,
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    { kind: "path", d: `M${x - 11} ${base - 20}h22l-3 16h-16Z`, fill: ILL_PALETTE.n3 },
    { kind: "rect", x: x - 12.5, y: base - 22, width: 25, height: 4.5, rx: 2.2, fill: ILL_PALETTE.n4 },
    { kind: "rect", x: x - 14, y: base - 4.5, width: 28, height: 4.5, rx: 2.2, fill: ILL_PALETTE.n4 }
  ];
};
var pencil = (x, base = 130) => [
  // The ink line rests fully dash-offset, i.e. invisible, so the still frame is clean.
  {
    kind: "path",
    anim: "ink",
    d: `M${x - 15} ${base - 1}h30`,
    fill: "none",
    stroke: ILL_PALETTE.n4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: 30,
    strokeDashoffset: 30
  },
  {
    kind: "g",
    anim: "write",
    origin: [x, base],
    children: [
      {
        kind: "g",
        transform: `rotate(24 ${x} ${base})`,
        children: [
          {
            kind: "rect",
            x: x - 3,
            y: base - 30,
            width: 6,
            height: 24,
            rx: 2,
            fill: ILL_PALETTE.n3
          },
          { kind: "path", d: `M${x - 3} ${base - 6}h6l-3 6Z`, fill: ILL_PALETTE.n4 },
          {
            kind: "rect",
            x: x - 3,
            y: base - 32,
            width: 6,
            height: 4,
            rx: 1.5,
            fill: ILL_PALETTE.n4
          }
        ]
      }
    ]
  }
];

// src/illustrations/scenes.ts
var conversations = () => [
  ...frame(),
  { kind: "rect", x: 54, y: 50, width: 60, height: 38, rx: 9, fill: ILL_PALETTE.n2 },
  bar(64, 61, 38, ILL_PALETTE.n3),
  bar(64, 71, 24, ILL_PALETTE.n3),
  // The tail is drawn outside the bobbing group so it stays anchored to the card.
  { kind: "path", d: "M78 110h14l-16 14Z", fill: ILL_PALETTE.accent },
  {
    kind: "g",
    anim: "bob",
    origin: [99, 96],
    children: [
      { kind: "rect", x: 72, y: 80, width: 54, height: 32, rx: 9, fill: ILL_PALETTE.accent },
      {
        kind: "rect",
        anim: "t1",
        x: 80,
        y: 89,
        width: 30,
        height: 4,
        rx: 2,
        fill: "#fff",
        opacity: 0.78
      },
      {
        kind: "rect",
        anim: "t2",
        x: 80,
        y: 98,
        width: 18,
        height: 4,
        rx: 2,
        fill: "#fff",
        opacity: 0.5
      }
    ]
  },
  ...cup(60)
];
var bookingRequests = () => [
  ...frame(),
  { kind: "rect", x: 60, y: 52, width: 58, height: 42, rx: 8, fill: ILL_PALETTE.n2 },
  { kind: "rect", x: 66, y: 64, width: 60, height: 46, rx: 8, fill: ILL_PALETTE.white },
  { kind: "circle", cx: 79, cy: 79, r: 7, fill: ILL_PALETTE.n3 },
  bar(91, 74, 27, ILL_PALETTE.n3),
  bar(91, 83, 17, ILL_PALETTE.n2),
  { kind: "rect", x: 74, y: 94, width: 26, height: 8, rx: 4, fill: ILL_PALETTE.n2 },
  {
    kind: "g",
    anim: "pulse",
    origin: [124, 62],
    children: [
      { kind: "circle", cx: 124, cy: 62, r: 9, fill: ILL_PALETTE.accent },
      {
        kind: "path",
        d: "M120 62.4l2.6 2.8 5-5.6",
        fill: "none",
        stroke: "#fff",
        strokeWidth: 2.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ]
  },
  ...plant(52, 130, true)
];
var reviews = () => [
  ...frame(),
  { kind: "rect", x: 56, y: 54, width: 68, height: 50, rx: 8, fill: ILL_PALETTE.white },
  { kind: "g", anim: "twinkle", origin: [68, 70], children: [star(68, 70, ILL_PALETTE.accent)] },
  star(82, 70, ILL_PALETTE.n3),
  star(96, 70, ILL_PALETTE.n3),
  star(110, 70, ILL_PALETTE.n3),
  star(124, 70, ILL_PALETTE.n2),
  bar(64, 84, 48, ILL_PALETTE.n2),
  bar(64, 93, 30, ILL_PALETTE.n2),
  ...pencil(122)
];
var earnings = () => [
  ...frame(),
  { kind: "rect", x: 74, y: 90, width: 17, height: 28, rx: 3, fill: ILL_PALETTE.n3 },
  { kind: "rect", x: 97, y: 74, width: 17, height: 44, rx: 3, fill: ILL_PALETTE.n4 },
  {
    kind: "rect",
    anim: "grow",
    origin: [128.5, 118],
    x: 120,
    y: 58,
    width: 17,
    height: 60,
    rx: 3,
    fill: ILL_PALETTE.accent
  },
  bar(72, 122, 65, ILL_PALETTE.n3, 3),
  ...pencil(55)
];
var calendar = () => [
  ...frame(),
  { kind: "rect", x: 54, y: 50, width: 72, height: 16, rx: 8, fill: ILL_PALETTE.n3 },
  { kind: "rect", x: 54, y: 60, width: 72, height: 50, rx: 8, fill: ILL_PALETTE.white },
  ...[0, 1, 2].flatMap(
    (r) => [0, 1, 2, 3].map((c) => {
      const on = r === 1 && c === 2;
      return {
        kind: "rect",
        anim: on ? "fade" : void 0,
        x: 62 + c * 16,
        y: 70 + r * 13,
        width: 7,
        height: 7,
        rx: 2.2,
        fill: on ? ILL_PALETTE.accent : ILL_PALETTE.n2
      };
    })
  ),
  ...cup(120)
];
var listings = () => [
  ...frame(),
  { kind: "path", d: "M58 78 92 50l34 28Z", fill: ILL_PALETTE.n3 },
  { kind: "rect", x: 64, y: 76, width: 56, height: 44, rx: 4, fill: ILL_PALETTE.n2 },
  { kind: "rect", x: 70, y: 86, width: 11, height: 11, rx: 2.5, fill: ILL_PALETTE.white },
  { kind: "rect", x: 103, y: 86, width: 11, height: 11, rx: 2.5, fill: ILL_PALETTE.white },
  // The front door carries the accent — the one element the widget is about.
  { kind: "path", d: "M84 120V102a8 8 0 0 1 16 0v18Z", fill: ILL_PALETTE.accent },
  ...plant(54, 130, true)
];
var rules = () => [
  ...frame(),
  { kind: "rect", x: 56, y: 52, width: 68, height: 54, rx: 8, fill: ILL_PALETTE.white },
  ...[0, 1, 2].flatMap((i) => {
    const y = 62 + i * 17;
    const on = i === 0;
    return [
      bar(64, y + 2, i === 2 ? 22 : 30, ILL_PALETTE.n3, 4.5),
      { kind: "rect", x: 100, y, width: 16, height: 9, rx: 4.5, fill: on ? ILL_PALETTE.accent : ILL_PALETTE.n2 },
      { kind: "circle", cx: on ? 111.5 : 104.5, cy: y + 4.5, r: 3.2, fill: ILL_PALETTE.white }
    ];
  }),
  ...cup(56)
];
var team = () => [
  ...frame(),
  ...[
    { x: 72, y: 88, f: ILL_PALETTE.n4 },
    { x: 94, y: 80, f: ILL_PALETTE.accent },
    { x: 116, y: 88, f: ILL_PALETTE.n3 }
  ].map(({ x, y, f }, i) => {
    const isAccent = i === 1;
    return {
      kind: "g",
      anim: isAccent ? "bob" : void 0,
      origin: isAccent ? [x, y] : void 0,
      children: [
        { kind: "circle", cx: x, cy: y, r: 19, fill: ILL_PALETTE.cut },
        { kind: "circle", cx: x, cy: y, r: 16, fill: f },
        { kind: "circle", cx: x, cy: y - 4, r: 5, fill: ILL_PALETTE.white, opacity: 0.92 },
        {
          kind: "path",
          d: `M${x - 8} ${y + 13}a8 8 0 0 1 16 0Z`,
          fill: ILL_PALETTE.white,
          opacity: 0.92
        }
      ]
    };
  }),
  ...pencil(54)
];
var coupons = () => [
  ...frame(),
  {
    kind: "g",
    anim: "tilt",
    origin: [90, 85],
    children: [
      { kind: "rect", x: 54, y: 66, width: 72, height: 38, rx: 6, fill: ILL_PALETTE.white },
      { kind: "path", d: "M104 66h16a6 6 0 0 1 6 6v26a6 6 0 0 1-6 6h-16Z", fill: ILL_PALETTE.accent },
      ...[70, 78, 86, 94].map((y) => ({
        kind: "rect",
        x: 101,
        y,
        width: 2.6,
        height: 5,
        rx: 1.3,
        fill: ILL_PALETTE.n3
      })),
      // Notches are punched in the container colour so they read as holes.
      { kind: "circle", cx: 54, cy: 85, r: 5, fill: ILL_PALETTE.cut },
      { kind: "circle", cx: 126, cy: 85, r: 5, fill: ILL_PALETTE.cut },
      bar(62, 76, 30, ILL_PALETTE.n3),
      bar(62, 88, 20, ILL_PALETTE.n2),
      { kind: "circle", cx: 110, cy: 79, r: 2.4, fill: "#fff" },
      { kind: "circle", cx: 119, cy: 91, r: 2.4, fill: "#fff" },
      {
        kind: "rect",
        x: 113,
        y: 76,
        width: 2.4,
        height: 18,
        rx: 1.2,
        fill: "#fff",
        transform: "rotate(24 114 85)"
      }
    ]
  },
  ...cup(90)
];
var notifications = () => [
  ...frame(),
  {
    kind: "g",
    anim: "ring",
    origin: [90, 50],
    children: [
      {
        kind: "path",
        d: "M90 48c-11 0-18 8-18 19v13l-6 9h48l-6-9V67c0-11-7-19-18-19Z",
        fill: ILL_PALETTE.n3
      },
      { kind: "circle", cx: 90, cy: 95, r: 6.5, fill: ILL_PALETTE.n4 }
    ]
  },
  { kind: "circle", anim: "pulse", origin: [115, 52], cx: 115, cy: 52, r: 8.5, fill: ILL_PALETTE.accent },
  { kind: "rect", x: 56, y: 106, width: 44, height: 7, rx: 3.5, fill: ILL_PALETTE.n2 },
  { kind: "rect", x: 56, y: 117, width: 30, height: 7, rx: 3.5, fill: ILL_PALETTE.white },
  ...plant(124)
];
var occupancy = () => [
  ...frame(),
  { kind: "circle", cx: 90, cy: 78, r: 29, fill: ILL_PALETTE.white },
  { kind: "circle", cx: 90, cy: 78, r: 24, fill: "none", stroke: ILL_PALETTE.n3, strokeWidth: 10 },
  {
    kind: "path",
    anim: "fade",
    d: "M90 54a24 24 0 0 1 17 7",
    fill: "none",
    stroke: ILL_PALETTE.accent,
    strokeWidth: 10,
    strokeLinecap: "round"
  },
  // The dash where a percentage would be. Not "0%" — that is a measurement.
  bar(84, 76, 12, ILL_PALETTE.n4, 4),
  ...plant(126)
];
var coffeeBreak = () => [
  ...frame(),
  {
    kind: "g",
    fill: "none",
    stroke: ILL_PALETTE.n4,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    children: [
      // Authored invisible, so a screenshot shows a mug and no wisps. Each names its
      // own pivot — the group's origin is inert because the group does not animate.
      {
        kind: "path",
        anim: "w1",
        d: "M82 70c-4.6-6 4.6-9 0-15",
        opacity: 0,
        origin: [82, 70]
      },
      {
        kind: "path",
        anim: "w2",
        d: "M92 74c-4.6-6 4.6-9 0-15",
        opacity: 0,
        origin: [92, 74]
      },
      {
        kind: "path",
        anim: "w3",
        d: "M101 70c-4.6-6 4.6-9 0-15",
        opacity: 0,
        origin: [101, 70]
      }
    ]
  },
  {
    kind: "path",
    d: "M110 92c12 0 12 18 0 18",
    fill: "none",
    stroke: ILL_PALETTE.accent,
    strokeWidth: 5,
    strokeLinecap: "round"
  },
  { kind: "path", d: "M70 84h40l-4.5 38h-31Z", fill: ILL_PALETTE.accent },
  { kind: "rect", x: 67, y: 79, width: 46, height: 7.5, rx: 3.7, fill: ILL_PALETTE.accent },
  { kind: "ellipse", cx: 90, cy: 82.5, rx: 19, ry: 3.2, fill: "#fff", opacity: 0.22 },
  { kind: "rect", x: 64, y: 122, width: 52, height: 6, rx: 3, fill: ILL_PALETTE.n4 },
  { kind: "g", anim: "fade", children: [star(56, 56, ILL_PALETTE.n3, 5.5)] },
  { kind: "g", anim: "fade2", children: [star(124, 64, ILL_PALETTE.n3, 4.4)] }
];
var activity = () => [
  ...frame(),
  { kind: "rect", x: 62, y: 42, width: 52, height: 80, rx: 5, fill: ILL_PALETTE.n3 },
  { kind: "rect", x: 68, y: 48, width: 40, height: 74, rx: 3, fill: ILL_PALETTE.white },
  { kind: "circle", cx: 101, cy: 86, r: 3.2, fill: ILL_PALETTE.n4 },
  {
    kind: "g",
    fill: "none",
    stroke: ILL_PALETTE.n4,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      { kind: "path", d: "M96 68H80" },
      { kind: "path", d: "M85 63l-5 5 5 5" }
    ]
  },
  {
    kind: "g",
    anim: "drift",
    origin: [88, 100],
    children: [
      // Only the in-arrow carries the accent, so one-accent holds with two arrows.
      {
        kind: "g",
        fill: "none",
        stroke: ILL_PALETTE.accent,
        strokeWidth: 3.4,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
          { kind: "path", d: "M78 100h16" },
          { kind: "path", d: "M89 95l5 5-5 5" }
        ]
      }
    ]
  },
  { kind: "rect", x: 66, y: 124, width: 44, height: 5, rx: 2.5, fill: ILL_PALETTE.n4 },
  ...plant(126)
];
var payouts = () => [
  ...frame(),
  { kind: "rect", x: 66, y: 46, width: 48, height: 22, rx: 4, fill: ILL_PALETTE.n3 },
  {
    kind: "g",
    anim: "bob",
    origin: [90, 66],
    children: [
      { kind: "rect", x: 70, y: 56, width: 40, height: 22, rx: 4, fill: ILL_PALETTE.accent },
      { kind: "circle", cx: 90, cy: 67, r: 5, fill: "#fff", opacity: 0.9 }
    ]
  },
  {
    kind: "path",
    d: "M90 84v14",
    fill: "none",
    stroke: ILL_PALETTE.n4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: [2, 4.5]
  },
  { kind: "rect", x: 60, y: 98, width: 60, height: 26, rx: 6, fill: ILL_PALETTE.n3 },
  { kind: "rect", x: 72, y: 104, width: 36, height: 5, rx: 2.5, fill: ILL_PALETTE.cut },
  ...plant(128)
];
var withdrawals = () => [
  ...frame(),
  { kind: "rect", x: 54, y: 52, width: 58, height: 48, rx: 8, fill: ILL_PALETTE.white },
  bar(62, 62, 28, ILL_PALETTE.n2),
  bar(62, 74, 40, ILL_PALETTE.n2),
  bar(62, 86, 22, ILL_PALETTE.n2),
  {
    kind: "g",
    anim: "drift",
    origin: [116, 52],
    children: [
      {
        kind: "path",
        d: "M108 60l19-17",
        fill: "none",
        stroke: ILL_PALETTE.accent,
        strokeWidth: 4,
        strokeLinecap: "round"
      },
      {
        kind: "path",
        d: "M117 43h10v10",
        fill: "none",
        stroke: ILL_PALETTE.accent,
        strokeWidth: 4,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ]
  },
  ...cup(118)
];
var documents = () => [
  ...frame(),
  {
    kind: "g",
    anim: "bob",
    origin: [88, 78],
    children: [
      { kind: "rect", x: 56, y: 54, width: 64, height: 48, rx: 8, fill: ILL_PALETTE.white },
      // Portrait panel: n3, never a drawn face — the scene stands in for somebody
      // else's identity document.
      { kind: "rect", x: 63, y: 62, width: 20, height: 24, rx: 4, fill: ILL_PALETTE.n3 },
      bar(89, 65, 24, ILL_PALETTE.n2),
      bar(89, 74, 18, ILL_PALETTE.n2),
      bar(63, 92, 46, ILL_PALETTE.n2),
      {
        kind: "path",
        d: "M66 96l44-36",
        fill: "none",
        stroke: ILL_PALETTE.accent,
        strokeWidth: 4,
        strokeLinecap: "round"
      }
    ]
  },
  ...plant(130)
];
var SEAL = { cx: 110, cy: 98, r: 12 };
var SEAL_DASH_STEP = 2 * Math.PI * SEAL.r / 6;
var idCardFace = () => [
  { kind: "rect", x: 52, y: 54, width: 64, height: 48, rx: 8, fill: ILL_PALETTE.white },
  { kind: "rect", x: 59, y: 62, width: 20, height: 24, rx: 4, fill: ILL_PALETTE.n3 },
  bar(85, 65, 24, ILL_PALETTE.n2),
  bar(85, 74, 17, ILL_PALETTE.n2),
  // Stops short of the seal: a stamp over the one un-redacted line reads as damage.
  bar(59, 92, 36, ILL_PALETTE.n2)
];
var identityVerified = () => [
  ...frame(),
  ...idCardFace(),
  {
    kind: "g",
    anim: "pulse",
    origin: [SEAL.cx, SEAL.cy],
    children: [
      { kind: "circle", cx: SEAL.cx, cy: SEAL.cy, r: SEAL.r, fill: ILL_PALETTE.accent },
      // The seal's inner rule and mark are WHITE on the accent disc, so one-accent holds.
      {
        kind: "circle",
        cx: SEAL.cx,
        cy: SEAL.cy,
        r: 9,
        fill: "none",
        stroke: "#fff",
        strokeWidth: 1.2,
        opacity: 0.5
      },
      {
        kind: "path",
        d: "M104.6 98.3l3.6 3.7 7-7.6",
        fill: "none",
        stroke: "#fff",
        strokeWidth: 2.6,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ]
  },
  ...cup(56)
];
var identityUnverified = () => [
  ...frame(),
  ...idCardFace(),
  {
    kind: "circle",
    anim: "fade",
    cx: SEAL.cx,
    cy: SEAL.cy,
    r: SEAL.r,
    fill: "none",
    stroke: ILL_PALETTE.accent,
    strokeWidth: 3,
    strokeDasharray: [SEAL_DASH_STEP * 0.55, SEAL_DASH_STEP * 0.45]
  },
  // Same cup, same place, as `identityVerified` — one picture in two states.
  ...cup(56)
];
var noMatch = () => [
  ...frame(true),
  {
    kind: "g",
    anim: "drift",
    origin: [90, 88],
    children: [
      {
        kind: "rect",
        x: 99,
        y: 97,
        width: 8,
        height: 24,
        rx: 4,
        fill: ILL_PALETTE.n3,
        transform: "rotate(-42 103 109)"
      },
      { kind: "circle", cx: 88, cy: 80, r: 23, fill: ILL_PALETTE.n3 },
      { kind: "circle", cx: 88, cy: 80, r: 16.5, fill: ILL_PALETTE.cut },
      bar(79, 78, 18, ILL_PALETTE.n3, 4)
    ]
  }
];
var ILL_SCENES = {
  conversations,
  bookingRequests,
  reviews,
  earnings,
  calendar,
  listings,
  rules,
  team,
  coupons,
  notifications,
  occupancy,
  coffeeBreak,
  activity,
  payouts,
  withdrawals,
  documents,
  identityVerified,
  identityUnverified,
  noMatch
};

// src/illustrations/pages.ts
var PAGE_VIEW_BOX = { width: 340, height: 260 };
var GROUND = 209;
var PAGE_ARCH_D = "M40 210V152a130 130 0 0 1 260 0v58Z";
var PAGE_SUBJECT_ZONE = { x: 96, y: 60, width: 148, height: 140 };
var WARM_SCALE = 1.7;
var en = (preset, at, dur) => ({ preset, at, dur });
var lbar = (x, y, w, fill, h = 7) => bar(x, y, w, fill, h);
var stage = (plain = false) => [
  {
    kind: "g",
    enter: en("fade", 0, 560),
    origin: [170, 210],
    children: [
      { kind: "path", d: PAGE_ARCH_D, fill: ILL_PALETTE.arch, opacity: plain ? 0.6 : 1 },
      {
        kind: "rect",
        x: 40,
        y: 166,
        width: 260,
        height: 44,
        fill: ILL_PALETTE.n2,
        opacity: plain ? 0.45 : 0.75
      }
    ]
  },
  {
    kind: "g",
    enter: en("widen", 180, 480),
    origin: [170, GROUND],
    children: [
      {
        kind: "ellipse",
        cx: 170,
        cy: GROUND,
        rx: 106,
        ry: 8,
        fill: ILL_PALETTE.ground,
        opacity: plain ? 0.5 : 1
      }
    ]
  }
];
var warm = (kind, x, flip = false) => ({
  kind: "g",
  transform: `translate(${x - 52 * WARM_SCALE} ${GROUND - 130 * WARM_SCALE}) scale(${WARM_SCALE})`,
  children: kind === "plant" ? plant(52, 130, flip) : kind === "cup" ? cup(52) : pencil(52)
});
var warmCue = (kind, x, at, flip = false) => ({
  kind: "g",
  enter: en("riseS", at, 460),
  children: [warm(kind, x, flip)]
});
var thread = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("inL", 340, 520),
    children: [
      { kind: "path", d: "M90 112h20l-8 18Z", fill: ILL_PALETTE.n2 },
      { kind: "rect", x: 76, y: 56, width: 108, height: 56, rx: 18, fill: ILL_PALETTE.n2 },
      lbar(94, 72, 66, ILL_PALETTE.n3),
      lbar(94, 88, 40, ILL_PALETTE.n3)
    ]
  },
  {
    kind: "g",
    enter: en("inR", 540, 540),
    children: [
      {
        kind: "g",
        anim: "bob",
        origin: [204, 149],
        children: [
          // The tail is inside the bobbing group here (unlike the widget
          // scene): at page scale the bubble is the whole subject.
          { kind: "path", d: "M246 176h-20l6 18Z", fill: ILL_PALETTE.accent },
          {
            kind: "rect",
            x: 152,
            y: 122,
            width: 104,
            height: 54,
            rx: 18,
            fill: ILL_PALETTE.accent
          },
          {
            kind: "circle",
            anim: "t1",
            cx: 178,
            cy: 149,
            r: 6.4,
            fill: "#fff",
            opacity: 0.82
          },
          {
            kind: "circle",
            anim: "t2",
            cx: 204,
            cy: 149,
            r: 6.4,
            fill: "#fff",
            opacity: 0.82
          },
          {
            kind: "circle",
            anim: "t1",
            cx: 230,
            cy: 149,
            r: 6.4,
            fill: "#fff",
            opacity: 0.82
          }
        ]
      }
    ]
  },
  warmCue("cup", 102, 760)
];
var conversations2 = () => [
  ...stage(),
  // The tray is drawn first so the letters stack out of it.
  {
    kind: "g",
    enter: en("rise", 300, 560),
    children: [
      { kind: "rect", x: 112, y: 76, width: 104, height: 68, rx: 6, fill: ILL_PALETTE.n2 },
      { kind: "rect", x: 104, y: 88, width: 104, height: 68, rx: 6, fill: ILL_PALETTE.n3 }
    ]
  },
  {
    kind: "g",
    enter: en("drop", 500, 560),
    children: [
      {
        kind: "g",
        anim: "bob",
        origin: [168, 96],
        children: [
          { kind: "rect", x: 118, y: 64, width: 100, height: 64, rx: 6, fill: ILL_PALETTE.accent },
          {
            kind: "path",
            d: "M118 72 168 104 218 72",
            fill: "none",
            stroke: "#fff",
            strokeWidth: 4,
            strokeLinejoin: "round",
            opacity: 0.85
          }
        ]
      }
    ]
  },
  {
    kind: "g",
    enter: en("rise", 200, 540),
    children: [
      { kind: "path", d: "M100 174h140l-12 34H112Z", fill: ILL_PALETTE.n3 },
      { kind: "rect", x: 92, y: 166, width: 156, height: 14, rx: 7, fill: ILL_PALETTE.n4 }
    ]
  },
  warmCue("plant", 78, 780, true)
];
var notifications2 = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("drop", 280, 620),
    children: [
      {
        kind: "g",
        anim: "ring",
        origin: [170, 58],
        children: [
          {
            kind: "path",
            d: "M170 56c-22 0-36 16-36 38v26l-12 18h96l-12-18V94c0-22-14-38-36-38Z",
            fill: ILL_PALETTE.n3
          },
          { kind: "circle", cx: 170, cy: 150, r: 13, fill: ILL_PALETTE.n4 }
        ]
      }
    ]
  },
  {
    kind: "g",
    enter: en("pop", 680, 460),
    origin: [218, 66],
    children: [
      {
        kind: "circle",
        anim: "pulse",
        origin: [218, 66],
        cx: 218,
        cy: 66,
        r: 17,
        fill: ILL_PALETTE.accent
      }
    ]
  },
  {
    kind: "g",
    enter: en("riseS", 500, 440),
    // n3, not the widget scene's n2: these rows sit ON the floor plane, which IS n2,
    // so an n2 row would be invisible.
    children: [{ kind: "rect", x: 102, y: 170, width: 90, height: 13, rx: 6.5, fill: ILL_PALETTE.n3 }]
  },
  {
    kind: "g",
    enter: en("riseS", 600, 440),
    children: [{ kind: "rect", x: 102, y: 190, width: 62, height: 13, rx: 6.5, fill: ILL_PALETTE.white }]
  },
  warmCue("plant", 250, 780)
];
var upcoming = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      {
        kind: "path",
        d: "M150 76V62a16 16 0 0 1 40 0v14",
        fill: "none",
        stroke: ILL_PALETTE.n4,
        strokeWidth: 8,
        strokeLinecap: "round"
      },
      { kind: "rect", x: 100, y: 74, width: 140, height: 104, rx: 16, fill: ILL_PALETTE.n3 },
      { kind: "rect", x: 100, y: 112, width: 140, height: 18, fill: ILL_PALETTE.n2 },
      { kind: "rect", x: 152, y: 108, width: 30, height: 26, rx: 6, fill: ILL_PALETTE.n4 }
    ]
  },
  {
    kind: "g",
    enter: en("pop", 680, 480),
    origin: [258, 82],
    children: [
      {
        kind: "g",
        anim: "sway",
        origin: [238, 82],
        children: [
          {
            kind: "g",
            transform: "rotate(12 264 82)",
            children: [
              {
                kind: "path",
                d: "M236 84 250 78",
                fill: "none",
                stroke: ILL_PALETTE.n4,
                strokeWidth: 3.4,
                strokeLinecap: "round"
              },
              {
                kind: "rect",
                x: 248,
                y: 70,
                width: 34,
                height: 24,
                rx: 6,
                fill: ILL_PALETTE.accent
              }
            ]
          }
        ]
      }
    ]
  },
  warmCue("plant", 82, 800, true)
];
var past = () => [
  ...stage(true),
  {
    kind: "g",
    enter: en("rise", 280, 560),
    children: [
      {
        kind: "rect",
        x: 104,
        y: 96,
        width: 128,
        height: 52,
        rx: 8,
        fill: ILL_PALETTE.n2,
        transform: "rotate(-9 168 122)"
      }
    ]
  },
  {
    kind: "g",
    enter: en("rise", 400, 560),
    children: [
      {
        kind: "rect",
        x: 104,
        y: 96,
        width: 128,
        height: 52,
        rx: 8,
        fill: ILL_PALETTE.n3,
        transform: "rotate(-3.5 168 122)"
      }
    ]
  },
  {
    kind: "g",
    enter: en("rise", 520, 560),
    children: [
      {
        kind: "g",
        transform: "rotate(3 168 122)",
        children: [
          { kind: "rect", x: 104, y: 96, width: 128, height: 52, rx: 8, fill: ILL_PALETTE.white },
          lbar(118, 108, 52, ILL_PALETTE.n3),
          lbar(118, 124, 32, ILL_PALETTE.n2)
        ]
      }
    ]
  },
  {
    kind: "g",
    enter: en("pop", 780, 500),
    origin: [212, 126],
    children: [
      {
        kind: "g",
        anim: "fade",
        children: [
          {
            kind: "g",
            transform: "rotate(-14 212 126)",
            children: [
              { kind: "circle", cx: 212, cy: 126, r: 22, fill: ILL_PALETTE.accent },
              {
                kind: "circle",
                cx: 212,
                cy: 126,
                r: 15.5,
                fill: "none",
                stroke: "#fff",
                strokeWidth: 3,
                opacity: 0.55
              }
            ]
          }
        ]
      }
    ]
  },
  warmCue("cup", 98, 880)
];
var properties = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      { kind: "path", d: "M96 118 170 62l74 56Z", fill: ILL_PALETTE.n3 },
      { kind: "rect", x: 108, y: 114, width: 124, height: 94, rx: 6, fill: ILL_PALETTE.n2 },
      { kind: "rect", x: 124, y: 134, width: 26, height: 26, rx: 5, fill: ILL_PALETTE.white },
      { kind: "rect", x: 190, y: 134, width: 26, height: 26, rx: 5, fill: ILL_PALETTE.white }
    ]
  },
  {
    kind: "g",
    enter: en("pop", 700, 500),
    origin: [170, 208],
    children: [
      // The front door carries the accent — the one thing the page is about.
      { kind: "path", anim: "fade", d: "M154 208v-40a16 16 0 0 1 32 0v40Z", fill: ILL_PALETTE.accent }
    ]
  },
  warmCue("plant", 84, 820, true)
];
var propertyGroups = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 560),
    children: [
      {
        kind: "rect",
        x: 104,
        y: 84,
        width: 128,
        height: 104,
        rx: 12,
        fill: ILL_PALETTE.n2,
        transform: "rotate(-4 168 136)"
      }
    ]
  },
  {
    kind: "g",
    enter: en("rise", 390, 560),
    children: [{ kind: "rect", x: 104, y: 92, width: 128, height: 104, rx: 12, fill: ILL_PALETTE.n3 }]
  },
  {
    kind: "g",
    enter: en("rise", 500, 560),
    children: [
      { kind: "rect", x: 104, y: 100, width: 128, height: 96, rx: 12, fill: ILL_PALETTE.white },
      { kind: "path", d: "M132 150 168 122l36 28Z", fill: ILL_PALETTE.n3 },
      { kind: "rect", x: 146, y: 147, width: 44, height: 30, rx: 5, fill: ILL_PALETTE.n2 },
      { kind: "rect", x: 161, y: 159, width: 14, height: 18, rx: 3, fill: ILL_PALETTE.n3 }
    ]
  },
  {
    kind: "g",
    enter: en("drop", 740, 520),
    origin: [168, 84],
    children: [
      {
        kind: "g",
        anim: "bob",
        origin: [168, 84],
        children: [
          {
            kind: "path",
            d: "M152 110V86a16 16 0 0 1 32 0v18",
            fill: "none",
            stroke: ILL_PALETTE.accent,
            strokeWidth: 8,
            strokeLinecap: "round"
          }
        ]
      }
    ]
  },
  warmCue("plant", 84, 840, true)
];
var bookingRules = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      { kind: "rect", x: 92, y: 62, width: 128, height: 106, rx: 14, fill: ILL_PALETTE.white },
      ...[0, 1, 2].map((i) => {
        const y = 80 + i * 32;
        return {
          kind: "g",
          enter: en("riseS", 440 + i * 100, 440),
          children: [
            lbar(106, y + 5, i === 2 ? 38 : 52, ILL_PALETTE.n3, 9),
            ...i > 0 ? [
              {
                kind: "rect",
                x: 168,
                y,
                width: 32,
                height: 18,
                rx: 9,
                fill: ILL_PALETTE.n2
              },
              {
                kind: "circle",
                cx: 177,
                cy: y + 9,
                r: 6.4,
                fill: ILL_PALETTE.white
              }
            ] : []
          ]
        };
      })
    ]
  },
  {
    kind: "g",
    enter: en("pop", 780, 480),
    origin: [184, 89],
    children: [
      { kind: "rect", x: 168, y: 80, width: 32, height: 18, rx: 9, fill: ILL_PALETTE.accent },
      { kind: "circle", anim: "fade", cx: 191, cy: 89, r: 6.4, fill: ILL_PALETTE.white }
    ]
  },
  warmCue("cup", 250, 880)
];
var pricingRules = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      { kind: "rect", x: 96, y: 66, width: 116, height: 92, rx: 12, fill: ILL_PALETTE.white },
      lbar(110, 86, 56, ILL_PALETTE.n3),
      lbar(110, 104, 36, ILL_PALETTE.n2),
      lbar(110, 122, 48, ILL_PALETTE.n2)
    ]
  },
  {
    kind: "g",
    enter: en("pop", 700, 500),
    origin: [204, 152],
    children: [
      {
        kind: "g",
        anim: "sway",
        origin: [172, 152],
        children: [
          {
            kind: "g",
            transform: "rotate(-8 204 152)",
            children: [
              {
                kind: "path",
                d: "M170 152l20-26h40a12 12 0 0 1 12 12v28a12 12 0 0 1-12 12h-40Z",
                fill: ILL_PALETTE.accent
              },
              { kind: "circle", cx: 194, cy: 152, r: 6.4, fill: "#fff" },
              {
                kind: "rect",
                x: 208,
                y: 139,
                width: 24,
                height: 6,
                rx: 3,
                fill: "#fff",
                opacity: 0.8
              },
              {
                kind: "rect",
                x: 208,
                y: 156,
                width: 16,
                height: 6,
                rx: 3,
                fill: "#fff",
                opacity: 0.55
              }
            ]
          }
        ]
      }
    ]
  },
  warmCue("plant", 82, 820, true)
];
var travelGuides = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 340, 600),
    children: [
      { kind: "path", d: "M108 190 170 198l62-8v12l-62 8-62-8Z", fill: ILL_PALETTE.n4 },
      { kind: "path", d: "M112 140 170 132v56l-58 8Z", fill: ILL_PALETTE.white },
      { kind: "path", d: "M174 132 228 140v64l-54-8Z", fill: ILL_PALETTE.n2 },
      ...[0, 1, 2].map((i) => {
        const w = i === 2 ? 22 : 32;
        const left = 148 + i * 13;
        const right = 152 + i * 13;
        return {
          kind: "g",
          enter: en("riseS", 620 + i * 80, 400),
          children: [
            {
              kind: "rect",
              x: 124,
              y: left,
              width: w,
              height: 5.5,
              rx: 2.7,
              fill: ILL_PALETTE.n3,
              transform: `rotate(-8 124 ${left})`
            },
            {
              kind: "rect",
              x: 184,
              y: right,
              width: w,
              height: 5.5,
              rx: 2.7,
              fill: ILL_PALETTE.n3,
              transform: `rotate(8 184 ${right})`
            }
          ]
        };
      })
    ]
  },
  {
    kind: "g",
    enter: en("drop", 660, 560),
    origin: [170, 118],
    children: [
      {
        kind: "g",
        anim: "bob",
        origin: [170, 118],
        children: [
          {
            kind: "path",
            d: "M170 58c-14.4 0-25 11-25 25 0 18 25 41 25 41s25-23 25-41c0-14-10.6-25-25-25Z",
            fill: ILL_PALETTE.accent
          },
          { kind: "circle", cx: 170, cy: 84, r: 8.8, fill: "#fff" }
        ]
      }
    ]
  },
  warmCue("plant", 252, 880)
];
var withdrawalsRequested = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      { kind: "rect", x: 96, y: 56, width: 136, height: 124, rx: 14, fill: ILL_PALETTE.white },
      lbar(112, 76, 74, ILL_PALETTE.n3, 9),
      ...[0, 1, 2].map((i) => ({
        kind: "g",
        enter: en("riseS", 460 + i * 90, 440),
        children: [lbar(112, 104 + i * 22, i === 2 ? 56 : 100, ILL_PALETTE.n2, 9)]
      }))
    ]
  },
  {
    kind: "g",
    enter: en("pop", 760, 500),
    origin: [224, 166],
    children: [
      {
        kind: "g",
        anim: "pulse",
        origin: [224, 166],
        children: [
          { kind: "circle", cx: 224, cy: 166, r: 32, fill: ILL_PALETTE.accent },
          {
            kind: "path",
            d: "M224 148v19l13 8",
            fill: "none",
            stroke: "#fff",
            strokeWidth: 5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ]
      }
    ]
  },
  // The pencil, because the neighbouring action is filling the form in.
  warmCue("pencil", 86, 880)
];
var cancellationPenalties = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 600),
    children: [
      {
        kind: "path",
        d: "M170 60l62 22v50c0 40-29 62-62 73-33-11-62-33-62-73V82Z",
        fill: ILL_PALETTE.n3
      },
      {
        kind: "path",
        d: "M170 78l44 15.6v36c0 28.4-20.6 44-44 51.8-23.4-7.8-44-23.4-44-51.8v-36Z",
        fill: ILL_PALETTE.white
      }
    ]
  },
  {
    kind: "g",
    enter: en("pop", 760, 480),
    origin: [170, 133],
    children: [{ kind: "g", anim: "fade", children: [lbar(152, 128, 36, ILL_PALETTE.accent, 11)] }]
  },
  warmCue("plant", 252, 860)
];
var penaltiesSettlement = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 580),
    children: [
      { kind: "rect", x: 167, y: 96, width: 6, height: 104, rx: 3, fill: ILL_PALETTE.n4 },
      { kind: "path", d: "M142 208h56l-11-14h-34Z", fill: ILL_PALETTE.n4 },
      { kind: "circle", cx: 170, cy: 90, r: 9, fill: ILL_PALETTE.n4 }
    ]
  },
  {
    kind: "g",
    enter: en("drop", 600, 560),
    origin: [170, 102],
    children: [
      {
        kind: "g",
        anim: "tilt",
        origin: [170, 102],
        children: [
          { kind: "rect", x: 92, y: 98, width: 156, height: 8, rx: 4, fill: ILL_PALETTE.accent },
          {
            kind: "path",
            d: "M110 106v8M230 106v8",
            stroke: ILL_PALETTE.n4,
            strokeWidth: 3,
            strokeLinecap: "round"
          },
          { kind: "path", d: "M88 114a22 22 0 0 0 44 0Z", fill: ILL_PALETTE.n3 },
          { kind: "path", d: "M208 114a22 22 0 0 0 44 0Z", fill: ILL_PALETTE.n3 }
        ]
      }
    ]
  },
  warmCue("cup", 100, 860)
];
var withdrawalMethods = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 280, 560),
    children: [{ kind: "rect", x: 100, y: 52, width: 132, height: 84, rx: 14, fill: ILL_PALETTE.n3 }]
  },
  {
    kind: "g",
    enter: en("rise", 420, 560),
    children: [
      { kind: "rect", x: 112, y: 70, width: 132, height: 84, rx: 14, fill: ILL_PALETTE.white },
      { kind: "rect", x: 128, y: 90, width: 32, height: 23, rx: 5, fill: ILL_PALETTE.n3 },
      lbar(128, 128, 76, ILL_PALETTE.n2, 9)
    ]
  },
  {
    kind: "g",
    enter: en("pop", 740, 500),
    origin: [160, 187],
    children: [
      {
        kind: "g",
        anim: "pulse",
        origin: [160, 187],
        children: [
          {
            kind: "rect",
            x: 98,
            y: 166,
            width: 124,
            height: 42,
            rx: 12,
            fill: "none",
            stroke: ILL_PALETTE.n4,
            strokeWidth: 3,
            strokeDasharray: [10, 8]
          },
          {
            kind: "path",
            d: "M160 175v24M148 187h24",
            stroke: ILL_PALETTE.accent,
            strokeWidth: 6,
            strokeLinecap: "round"
          }
        ]
      }
    ]
  },
  warmCue("pencil", 254, 860)
];
var couponsCreated = () => [
  ...stage(),
  {
    kind: "g",
    enter: en("rise", 300, 580),
    children: [
      {
        kind: "path",
        d: "M100 96h132v30a14 14 0 0 0 0 28v30H100v-30a14 14 0 0 0 0-28Z",
        fill: "none",
        stroke: ILL_PALETTE.n4,
        strokeWidth: 3,
        strokeDasharray: [12, 9]
      },
      lbar(120, 112, 52, ILL_PALETTE.n2),
      lbar(120, 172, 34, ILL_PALETTE.n2)
    ]
  },
  {
    kind: "g",
    enter: en("pop", 720, 500),
    origin: [166, 140],
    children: [
      {
        kind: "g",
        anim: "pulse",
        origin: [166, 140],
        children: [
          { kind: "circle", cx: 166, cy: 140, r: 30, fill: ILL_PALETTE.accent },
          {
            kind: "path",
            d: "M166 124v32M150 140h32",
            stroke: "#fff",
            strokeWidth: 6,
            strokeLinecap: "round"
          }
        ]
      }
    ]
  },
  warmCue("cup", 252, 850)
];
var page = (nodes, plain = false) => ({
  ...PAGE_VIEW_BOX,
  dur: 2e3,
  ...plain ? { plain: true } : {},
  nodes
});
var ILL_PAGE_SCENES = {
  thread: page(thread),
  conversations: page(conversations2),
  notifications: page(notifications2),
  upcoming: page(upcoming),
  past: page(past, true),
  properties: page(properties),
  propertyGroups: page(propertyGroups),
  bookingRules: page(bookingRules),
  pricingRules: page(pricingRules),
  travelGuides: page(travelGuides),
  withdrawalsRequested: page(withdrawalsRequested),
  cancellationPenalties: page(cancellationPenalties),
  penaltiesSettlement: page(penaltiesSettlement),
  withdrawalMethods: page(withdrawalMethods),
  couponsCreated: page(couponsCreated)
};
var ILL_PAGE_NAMES = Object.keys(ILL_PAGE_SCENES);

// src/illustrations/motion.ts
var ILL_MOTION = {
  sway: { duration: 5200 },
  leaf1: { duration: 3800 },
  leaf2: { duration: 4600, reverse: true },
  leaf3: { duration: 5400 },
  w1: { duration: 3400, easing: "out" },
  w2: { duration: 3400, delay: 950, easing: "out" },
  w3: { duration: 3400, delay: 1900, easing: "out" },
  write: { duration: 2800 },
  ink: { duration: 2800 },
  ring: { duration: 4600 },
  pulse: { duration: 2600 },
  bob: { duration: 3400 },
  t1: { duration: 1400 },
  t2: { duration: 1400, delay: 350 },
  twinkle: { duration: 3e3 },
  grow: { duration: 3600 },
  fade: { duration: 2400 },
  // Same shape, offset a beat, so two sparks on one scene never blink together.
  fade2: { duration: 2400, delay: 1200 },
  tilt: { duration: 5e3 },
  drift: { duration: 6e3 }
};
var ILL_KEYFRAME = {
  sway: "sway",
  leaf1: "leaf",
  leaf2: "leaf",
  leaf3: "leaf",
  w1: "steam",
  w2: "steam",
  w3: "steam",
  write: "write",
  ink: "ink",
  ring: "ring",
  pulse: "pulse",
  bob: "bob",
  t1: "type",
  t2: "type",
  twinkle: "twinkle",
  grow: "grow",
  fade: "fade",
  fade2: "fade",
  tilt: "tilt",
  drift: "drift"
};
var ILL_EASING = {
  /** Entrances, slides, fades — anything arriving. */
  glide: [0.22, 0.7, 0.2, 1],
  /** The accent, and anything that drops in. */
  pop: [0.2, 1.25, 0.3, 1.2]
};
var ILL_ENTER = {
  fade: { easing: "glide", dur: 460 },
  widen: { easing: "glide", dur: 440 },
  rise: { easing: "glide", dur: 520 },
  riseS: { easing: "glide", dur: 420 },
  drop: { easing: "pop", dur: 520 },
  pop: { easing: "pop", dur: 420 },
  inL: { easing: "glide", dur: 460 },
  inR: { easing: "glide", dur: 460 }
};
var ILL_PAGE_TEXT = {
  dur: 460,
  /** ms, by slot: title, body, action. */
  at: [520, 600, 690]
};
var ILL_PAGE_DUR = 2e3;

// src/events/palette.ts
var EV_PALETTE = {
  /** The subject. One per scene. */
  crimson: "#C5142A",
  crimsonDeep: "#A8122A",
  crimsonSoft: "#F7DDDF",
  /** Celebration / good but not yet settled: pending, offers, proposed changes. */
  amber: "#E2A03F",
  amberSoft: "#FBEBD3",
  /** Celebration only. */
  blush: "#F0A9AE",
  n2: "#EFE7DB",
  n3: "#DED2C2",
  n4: "#C0B2A0",
  white: "#FFFFFF",
  /** The soft shadow under a hero object. */
  ground: "#E6DACA"
};
var EV_MUTED_OPACITY = 0.62;

// src/events/motion.ts
var EV_EASING = {
  /** Anything arriving. */
  glide: [0.22, 0.7, 0.2, 1],
  /** Anything appearing in place. */
  pop: [0.2, 1.25, 0.3, 1.2],
  /** The approval seal, nothing else. */
  snap: [0.16, 1.5, 0.3, 1],
  /** Every idle loop. */
  calm: [0.4, 0, 0.5, 1],
  /** The sun's rays. */
  linear: [0, 0, 1, 1]
};
var EV_ENTER = {
  rise: { easing: "glide", dur: 560 },
  riseS: { easing: "glide", dur: 420 },
  drop: { easing: "pop", dur: 520 },
  pop: { easing: "pop", dur: 420 },
  inR: { easing: "glide", dur: 480 },
  seal: { easing: "snap", dur: 520 },
  burst: { easing: "glide", dur: 1100, params: ["tx", "ty", "rot"], restsHidden: true },
  grow: { easing: "pop", dur: 520 },
  widen: { easing: "glide", dur: 520 },
  draw: { easing: "calm", dur: 600, params: ["len"] },
  lift: { easing: "glide", dur: 700 },
  fan: { easing: "pop", dur: 520 },
  /**
   * Appear, hold, leave to the left — a transient element in one cue. A plain fade-OUT
   * must be authored visible, so it would snap back when the sequence ends.
   */
  swap: { easing: "glide", dur: 880, restsHidden: true },
  /** Four diminishing swings about the node's `origin`. `calm` per segment, so each swing eases both ways. */
  rattle: { easing: "calm", dur: 560 }
};
var EV_IDLE = {
  float: { duration: 4400, easing: "calm" },
  floatS: { duration: 3600, easing: "calm" },
  twinkle: { duration: 2600, easing: "calm" },
  pending: { duration: 1500, easing: "calm" },
  spin: { duration: 9e3, easing: "linear" },
  sway: { duration: 5200, easing: "calm" },
  shimmer: { duration: 2600, easing: "calm" },
  // Linear: an eased ferry reads as a bounce, not as work being done.
  ferry: { duration: 2700, easing: "linear" },
  indet: { duration: 1600, easing: "calm" },
  breathe: { duration: 2e3, easing: "calm" }
};
var EV_FERRY_STAGGER = 900;
var EV_IDLE_STAGGER = 450;
var idleDelay = (n) => n * EV_IDLE_STAGGER;
var EV_PLAY_TAIL = 400;

// src/events/primitives.ts
var bar2 = (x, y, w, h, fill, r) => ({
  kind: "rect",
  x,
  y,
  width: w,
  height: h,
  rx: r === void 0 ? h / 2 : r,
  fill
});
var sparkle = (cx, cy, s = 6, fill = EV_PALETTE.amber, delay = 0) => ({
  kind: "g",
  anim: { key: "twinkle", delay },
  origin: [cx, cy],
  children: [
    {
      kind: "path",
      fill,
      transform: `translate(${cx} ${cy}) scale(${s})`,
      d: "M0-1C.12-.34.34-.12 1 0 .34.12.12.34 0 1-.12.34-.34.12-1 0-.34-.12-.12-.34 0-1Z"
    }
  ]
});
var sparkPop = (cx, cy, s, fill, at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 380 },
  origin: [cx, cy],
  children: [
    {
      kind: "path",
      fill,
      transform: `translate(${cx} ${cy}) scale(${s})`,
      d: "M0-1C.12-.34.34-.12 1 0 .34.12.12.34 0 1-.12.34-.34.12-1 0-.34-.12-.12-.34 0-1Z"
    }
  ]
});
var star5 = (cx, cy, s, fill, twinkles = false) => ({
  kind: "g",
  anim: twinkles ? { key: "twinkle" } : void 0,
  origin: [cx, cy],
  children: [
    {
      kind: "path",
      fill,
      transform: `translate(${cx} ${cy}) scale(${s})`,
      d: "M0-1 .29-.32 1-.31.45.13.62.81 0 .42-.62.81-.45.13-1-.31-.29-.32Z"
    }
  ]
});
var CONFETTI = [
  [-86, -54, 214, "r", EV_PALETTE.crimson],
  [-58, -78, -168, "c", EV_PALETTE.amber],
  [-28, -92, 132, "r", EV_PALETTE.blush],
  [4, -100, -96, "r", EV_PALETTE.crimson],
  [36, -92, 178, "c", EV_PALETTE.amber],
  [66, -74, -140, "r", EV_PALETTE.blush],
  [92, -46, 118, "r", EV_PALETTE.amber],
  [104, -12, -196, "c", EV_PALETTE.crimson],
  [-100, -18, 156, "c", EV_PALETTE.blush],
  [-78, 16, -122, "r", EV_PALETTE.amber],
  [-42, 40, 188, "r", EV_PALETTE.crimson],
  [-6, 52, -150, "c", EV_PALETTE.amber],
  [32, 44, 126, "r", EV_PALETTE.blush],
  [68, 24, -172, "r", EV_PALETTE.crimson],
  [88, 2, 144, "c", EV_PALETTE.amber],
  [-116, -34, -110, "r", EV_PALETTE.crimson]
];
var confetti = (cx, cy, at, spread = 1) => CONFETTI.map(([tx, ty, rot, shape, fill], i) => {
  const enter = {
    preset: "burst",
    at: at + i % 4 * 55,
    dur: 1e3 + i % 3 * 180,
    tx: tx * spread,
    ty: ty * spread,
    rot
  };
  return shape === "r" ? {
    kind: "rect",
    x: cx - 2.6,
    y: cy - 5,
    width: 5.2,
    height: 10,
    rx: 2.2,
    fill,
    opacity: 0,
    enter,
    origin: [cx, cy]
  } : {
    kind: "circle",
    cx,
    cy,
    r: 3.6,
    fill,
    opacity: 0,
    enter,
    origin: [cx, cy]
  };
});
var seal = (cx, cy, r, at) => {
  const len = r > 24 ? 34 : 30;
  const k = r / 26;
  return {
    kind: "g",
    enter: { preset: "seal", at, dur: 520 },
    origin: [cx, cy],
    children: [
      { kind: "circle", cx, cy, r, fill: EV_PALETTE.crimson },
      {
        kind: "circle",
        cx,
        cy,
        r: r - 5,
        fill: "none",
        stroke: EV_PALETTE.white,
        strokeWidth: 1.4,
        opacity: 0.45
      },
      {
        kind: "path",
        enter: { preset: "draw", at: at + 260, dur: 340, len },
        d: `M${cx - 9 * k} ${cy + 0.5}l${6.4 * k} ${6.6 * k}L${cx + 10 * k} ${cy - 8 * k}`,
        fill: "none",
        stroke: EV_PALETTE.white,
        strokeWidth: 4.2 * k,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: len
      }
    ]
  };
};
var sun = (cx, cy, r, at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 460 },
  origin: [cx, cy],
  children: [
    {
      kind: "g",
      anim: { key: "spin" },
      origin: [cx, cy],
      children: [0, 45, 90, 135, 180, 225, 270, 315].map((a) => ({
        kind: "rect",
        x: cx - 1.4,
        y: cy - r - 8,
        width: 2.8,
        height: 5.5,
        rx: 1.4,
        fill: EV_PALETTE.amber,
        transform: `rotate(${a} ${cx} ${cy})`
      }))
    },
    { kind: "circle", cx, cy, r, fill: EV_PALETTE.amber },
    { kind: "circle", cx, cy, r: r - 4.5, fill: EV_PALETTE.white, opacity: 0.22 }
  ]
});
var photo = (x, y, w, h, fill, tint) => {
  const iw = w - 14;
  const ih = h - 24;
  return [
    { kind: "rect", x, y, width: w, height: h, rx: 10, fill },
    { kind: "rect", x: x + 7, y: y + 7, width: iw, height: ih, rx: 6, fill: tint },
    {
      kind: "path",
      d: `M${x + 7} ${y + h - 17}l${iw * 0.34} -${ih * 0.44} ${iw * 0.22} ${ih * 0.2} ${iw * 0.16} -${ih * 0.14} ${iw * 0.28} ${ih * 0.38}Z`,
      fill: EV_PALETTE.n4,
      opacity: 0.55
    },
    { kind: "circle", cx: x + 20, cy: y + 20, r: 5, fill: EV_PALETTE.amber, opacity: 0.9 }
  ];
};
var slotPill = (x, y, w, h, fill, dotFill, stroke) => [
  {
    kind: "rect",
    x,
    y,
    width: w,
    height: h,
    rx: h / 2,
    fill,
    stroke,
    strokeWidth: stroke ? 2 : void 0
  },
  { kind: "circle", cx: x + h * 0.6, cy: y + h / 2, r: h * 0.22, fill: dotFill }
];
var shadow = (cx, cy, rx, ry = 6, at = 120) => ({
  kind: "ellipse",
  enter: { preset: "pop", at, dur: 520 },
  origin: [cx, cy],
  cx,
  cy,
  rx,
  ry,
  fill: EV_PALETTE.ground
});

// src/events/banners.ts
var SIZE = { x: 194, y: 52, width: 404, height: 184 };
var strokeGroup = (c, children) => ({
  kind: "g",
  fill: "none",
  stroke: c,
  strokeWidth: 3.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children
});
var glyph = (kind, cx, cy, c) => {
  switch (kind) {
    case "wifi":
      return strokeGroup(c, [
        { kind: "path", d: `M${cx - 13} ${cy - 1}a19 19 0 0 1 26 0` },
        { kind: "path", d: `M${cx - 7} ${cy + 7}a11 11 0 0 1 14 0` },
        { kind: "circle", cx, cy: cy + 15, r: 2.4, fill: c, stroke: "none" }
      ]);
    case "pool":
      return strokeGroup(c, [
        { kind: "path", d: `M${cx - 14} ${cy + 8}q7-7 14 0t14 0` },
        { kind: "path", d: `M${cx - 14} ${cy - 2}q7-7 14 0t14 0` },
        { kind: "circle", cx: cx + 8, cy: cy - 13, r: 3.4, fill: c, stroke: "none" }
      ]);
    case "kitchen":
      return strokeGroup(c, [
        {
          kind: "path",
          d: `M${cx - 9} ${cy - 15}v12a5 5 0 0 0 10 0v-12M${cx - 4} ${cy - 3}v18`
        },
        { kind: "path", d: `M${cx + 10} ${cy - 15}c5 3 5 10 0 12v18` }
      ]);
    default:
      return strokeGroup(c, [
        { kind: "path", d: `M${cx - 14} ${cy + 12}v-20h20a8 8 0 0 1 8 8v12` },
        { kind: "path", d: `M${cx - 14} ${cy + 3}h28` },
        { kind: "circle", cx: cx - 5, cy: cy - 4, r: 3.4, fill: c, stroke: "none" }
      ]);
  }
};
var selectedCheck = (cx, cy, at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 340 },
  origin: [cx, cy],
  children: [
    { kind: "circle", cx, cy, r: 11, fill: EV_PALETTE.amber },
    {
      kind: "path",
      d: `M${cx - 5} ${cy}l3.4 3.6 6-6.6`,
      fill: "none",
      stroke: EV_PALETTE.white,
      strokeWidth: 2.6,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ]
});
var photoHorizon = (left, front) => [
  {
    kind: "path",
    d: `M${left + 8} 172l26-24 20 17 14-11 24 18v0h-84Z`,
    fill: front ? EV_PALETTE.n4 : EV_PALETTE.n3,
    opacity: 0.8
  },
  { kind: "circle", cx: left + 26, cy: 134, r: 6, fill: front ? EV_PALETTE.amber : EV_PALETTE.n3 }
];
var photographyFan = (frontPicture) => {
  const shots = [
    { x: 262, rot: -13, fill: EV_PALETTE.n3, at: 200 },
    { x: 330, rot: -5, fill: EV_PALETTE.n2, at: 360 },
    { x: 398, rot: 5, fill: EV_PALETTE.white, at: 520 }
  ];
  return [
    shadow(380, 208, 160, 7, 60),
    ...shots.map((s, i) => {
      const front = i === 2;
      return {
        kind: "g",
        enter: { preset: "fan", at: s.at, dur: 540 },
        origin: [s.x + 50, 200],
        children: [
          {
            kind: "g",
            transform: `rotate(${s.rot} ${s.x + 50} 200)`,
            children: [
              {
                kind: "rect",
                x: s.x,
                y: 112,
                width: 100,
                height: 88,
                rx: 10,
                fill: s.fill
              },
              {
                kind: "rect",
                x: s.x + 8,
                y: 120,
                width: 84,
                height: 52,
                rx: 6,
                fill: front ? EV_PALETTE.n2 : EV_PALETTE.white,
                opacity: front ? 1 : 0.55
              },
              ...front ? frontPicture(s.x) : photoHorizon(s.x, false),
              bar2(s.x + 10, 180, 52, 7, EV_PALETTE.n4)
            ]
          }
        ]
      };
    }),
    {
      kind: "g",
      enter: { preset: "pop", at: 760, dur: 460 },
      origin: [498, 118],
      children: [
        { kind: "circle", cx: 498, cy: 118, r: 24, fill: EV_PALETTE.crimson },
        {
          kind: "path",
          d: "M498 106v24M486 118h24",
          fill: "none",
          stroke: EV_PALETTE.white,
          strokeWidth: 4,
          strokeLinecap: "round"
        }
      ]
    },
    {
      kind: "g",
      enter: { preset: "widen", at: 1020, dur: 620 },
      origin: [286, 0],
      children: [
        { kind: "rect", x: 286, y: 224, width: 188, height: 10, rx: 5, fill: EV_PALETTE.n3 },
        // Authored invisible: the sweep loops, and reduced motion must not
        // leave a solid amber bar over the fill.
        {
          kind: "rect",
          anim: { key: "shimmer" },
          opacity: 0,
          x: 286,
          y: 224,
          width: 188,
          height: 10,
          rx: 5,
          fill: EV_PALETTE.amber
        },
        {
          kind: "rect",
          x: 286,
          y: 224,
          width: 126,
          height: 10,
          rx: 5,
          fill: EV_PALETTE.crimson
        }
      ]
    },
    sparkle(214, 98, 6, EV_PALETTE.amber),
    sparkle(568, 172, 5, EV_PALETTE.blush, idleDelay(2))
  ];
};
var loaderTrack = (enter) => ({
  kind: "g",
  enter,
  origin: [292, 0],
  children: [
    { kind: "rect", x: 292, y: 224, width: 180, height: 10, rx: 5, fill: EV_PALETTE.n2 },
    {
      kind: "g",
      clip: { x: 292, y: 224, width: 180, height: 10, rx: 5 },
      children: [
        {
          kind: "rect",
          anim: { key: "indet" },
          x: 228,
          y: 224,
          width: 58,
          height: 10,
          rx: 5,
          fill: EV_PALETTE.crimson
        }
      ]
    }
  ]
});
var experienceLandmark = (enter) => ({
  kind: "g",
  enter,
  // Grows from its foot, not its middle.
  origin: [474, 220],
  children: [
    { kind: "rect", x: 424, y: 202, width: 100, height: 18, rx: 5, fill: EV_PALETTE.n3 },
    { kind: "rect", x: 436, y: 138, width: 76, height: 64, rx: 4, fill: EV_PALETTE.n2 },
    // The arch is the OPENING cut through the block, not a rounded body.
    { kind: "path", d: "M458 202V168a16 16 0 0 1 32 0V202Z", fill: EV_PALETTE.white },
    { kind: "rect", x: 428, y: 124, width: 92, height: 15, rx: 4, fill: EV_PALETTE.n3 },
    { kind: "rect", x: 444, y: 112, width: 60, height: 13, rx: 4, fill: EV_PALETTE.n3 }
  ]
});
var EXPERIENCE_GUESTS = [
  { x: 276, fill: EV_PALETTE.n3 },
  { x: 382, fill: EV_PALETTE.n4 }
];
var experienceGuest = (guest, enter) => ({
  kind: "g",
  enter,
  children: [
    { kind: "path", d: `M${guest.x} 212v-20a11 11 0 0 1 22 0v20Z`, fill: guest.fill },
    { kind: "circle", cx: guest.x + 11, cy: 171, r: 9, fill: guest.fill }
  ]
});
var experienceGuide = (enter) => ({
  kind: "g",
  enter,
  children: [
    { kind: "path", d: "M318 220v-30a14 14 0 0 1 28 0v30Z", fill: EV_PALETTE.crimson },
    { kind: "circle", cx: 332, cy: 166, r: 11, fill: EV_PALETTE.crimson },
    {
      kind: "path",
      d: "M338 192 352 184",
      fill: "none",
      stroke: EV_PALETTE.crimson,
      strokeWidth: 7,
      strokeLinecap: "round"
    }
  ]
});
var experiencePennant = (enter) => ({
  kind: "g",
  enter,
  origin: [352, 190],
  children: [
    {
      kind: "g",
      anim: { key: "sway" },
      // Pivots at the HAND — at the ground the pole runs through the guide.
      origin: [352, 190],
      children: [
        {
          kind: "rect",
          x: 349.5,
          y: 138,
          width: 5,
          height: 52,
          rx: 2.5,
          fill: EV_PALETTE.crimsonDeep
        },
        { kind: "path", d: "M354.5 141 388 152.5 354.5 164Z", fill: EV_PALETTE.crimsonDeep }
      ]
    }
  ]
});
var EXPERIENCE_STACK = [
  { x: 236, y: 150, rot: -7, fill: EV_PALETTE.n3, dot: EV_PALETTE.n4 },
  { x: 244, y: 172, rot: -3, fill: EV_PALETTE.n2, dot: EV_PALETTE.amber },
  { x: 252, y: 194, rot: 2, fill: EV_PALETTE.white, dot: EV_PALETTE.amber, stroke: EV_PALETTE.n3 }
];
var SERVICE_CELLS = [266, 320, 374, 428, 482];
var SERVICE_TAKEN = 3;
var serviceHours = (enter) => ({
  kind: "g",
  enter,
  // Widens from the row's LEFT edge: the hours unroll rather than inflate.
  origin: [SERVICE_CELLS[0], 0],
  children: SERVICE_CELLS.map((x, i) => {
    const taken = i === SERVICE_TAKEN;
    return {
      kind: "rect",
      x,
      y: 178,
      width: 44,
      height: 34,
      rx: 10,
      // The white hour needs the edge to read as a cell, not a hole. Stays
      // white, not `amberSoft`: amber touches the tick and nothing else here.
      fill: taken ? EV_PALETTE.white : EV_PALETTE.n2,
      stroke: taken ? EV_PALETTE.n3 : void 0,
      strokeWidth: taken ? 2 : void 0
    };
  })
});
var serviceProvider = (enter) => ({
  kind: "g",
  enter,
  children: [
    { kind: "path", d: "M328 178v-30a15 15 0 0 1 30 0v30Z", fill: EV_PALETTE.crimson },
    { kind: "circle", cx: 343, cy: 122, r: 12, fill: EV_PALETTE.crimson },
    {
      kind: "path",
      d: "M350 154 372 142",
      fill: "none",
      stroke: EV_PALETTE.crimson,
      strokeWidth: 7,
      strokeLinecap: "round"
    }
  ]
});
var serviceKit = (enter) => ({
  kind: "g",
  enter,
  children: [
    {
      kind: "g",
      anim: { key: "floatS" },
      children: [
        // FLAT, wide handle over a wide case — a tall one draws a padlock.
        {
          kind: "path",
          d: "M372 146v-4a12 6 0 0 1 24 0v4",
          fill: "none",
          stroke: EV_PALETTE.n4,
          strokeWidth: 3.4,
          strokeLinecap: "round"
        },
        { kind: "rect", x: 360, y: 146, width: 48, height: 28, rx: 6, fill: EV_PALETTE.n3 },
        { kind: "rect", x: 360, y: 157, width: 48, height: 3, fill: EV_PALETTE.n4 },
        { kind: "rect", x: 377, y: 154, width: 14, height: 9, rx: 2.5, fill: EV_PALETTE.n4 }
      ]
    }
  ]
});
var SERVICE_STACK = [
  { x: 230, y: 152, rot: -8, fill: EV_PALETTE.n3, dot: EV_PALETTE.n4 },
  { x: 238, y: 172, rot: -3, fill: EV_PALETTE.n2, dot: EV_PALETTE.amber },
  { x: 246, y: 192, rot: 3, fill: EV_PALETTE.white, dot: EV_PALETTE.amber, stroke: EV_PALETTE.n3 }
];
var SERVICE_DAYS = [417, 447, 477, 507, 537];
var EV_BANNER_SCENES = {
  /** Property creation flow, first step. Builds once, then breathes. */
  property_animation: {
    ...SIZE,
    dur: 1900,
    idle: true,
    nodes: () => [
      shadow(380, 222, 150, 8, 60),
      {
        kind: "g",
        anim: { key: "floatS" },
        children: [
          {
            // Square top corners: an `rx` rounds the top too and steps
            // the roof away from the wall.
            kind: "path",
            enter: { preset: "grow", at: 240, dur: 560 },
            origin: [380, 216],
            d: "M308 128h144v82a6 6 0 0 1 -6 6h-132a6 6 0 0 1 -6 -6Z",
            fill: EV_PALETTE.n2
          },
          {
            kind: "g",
            enter: { preset: "drop", at: 640, dur: 560 },
            // Base sits exactly on the wall top, with an 8-unit eave.
            children: [{ kind: "path", d: "M300 128 380 66l80 62Z", fill: EV_PALETTE.n3 }]
          },
          {
            kind: "g",
            enter: { preset: "pop", at: 1080, dur: 400 },
            origin: [380, 190],
            children: [
              {
                kind: "path",
                d: "M362 216v-32a18 18 0 0 1 36 0v32Z",
                fill: EV_PALETTE.crimson
              },
              {
                kind: "circle",
                cx: 390,
                cy: 200,
                r: 2.6,
                fill: EV_PALETTE.white,
                opacity: 0.7
              }
            ]
          },
          {
            kind: "rect",
            enter: { preset: "pop", at: 1240, dur: 360 },
            origin: [335, 160],
            x: 320,
            y: 146,
            width: 30,
            height: 28,
            rx: 5,
            fill: EV_PALETTE.white
          },
          {
            kind: "rect",
            enter: { preset: "pop", at: 1340, dur: 360 },
            origin: [425, 160],
            x: 410,
            y: 146,
            width: 30,
            height: 28,
            rx: 5,
            fill: EV_PALETTE.white
          }
        ]
      },
      {
        kind: "g",
        enter: { preset: "riseS", at: 1480, dur: 460 },
        children: [
          {
            kind: "g",
            anim: { key: "sway" },
            origin: [278, 214],
            children: [
              {
                kind: "ellipse",
                cx: 271,
                cy: 190,
                rx: 5,
                ry: 10,
                transform: "rotate(-26 271 190)",
                fill: EV_PALETTE.n4
              },
              {
                kind: "ellipse",
                cx: 285,
                cy: 192,
                rx: 5,
                ry: 9.4,
                transform: "rotate(26 285 192)",
                fill: EV_PALETTE.n3
              },
              { kind: "ellipse", cx: 278, cy: 182, rx: 4.8, ry: 11, fill: EV_PALETTE.n4 }
            ]
          },
          { kind: "path", d: "M270 202h16l-2.2 14h-11.6Z", fill: EV_PALETTE.n3 },
          { kind: "rect", x: 268, y: 199, width: 20, height: 5, rx: 2.4, fill: EV_PALETTE.n4 }
        ]
      },
      sun(520, 82, 16, 1560),
      sparkle(244, 92, 6, EV_PALETTE.amber),
      sparkle(492, 168, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(566, 140, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  },
  /** Wizard step — select amenities. Tiles land once, then float. */
  property_amenities: {
    ...SIZE,
    dur: 1800,
    idle: true,
    nodes: () => {
      const tiles = [
        { x: 236, ic: "wifi", on: false },
        { x: 316, ic: "pool", on: true },
        { x: 396, ic: "kitchen", on: false },
        { x: 476, ic: "bed", on: true }
      ];
      return [
        // Sits just under the tile row — lower, it reads as a loose ellipse.
        shadow(380, 196, 152, 7, 60),
        ...tiles.map((t, i) => {
          const at = 200 + i * 170;
          return {
            kind: "g",
            enter: { preset: "pop", at, dur: 480 },
            origin: [t.x + 34, 152],
            children: [
              {
                kind: "g",
                anim: { key: i % 2 ? "floatS" : "float", delay: idleDelay(i) },
                children: [
                  {
                    kind: "rect",
                    x: t.x,
                    y: 118,
                    width: 68,
                    height: 68,
                    rx: 20,
                    fill: t.on ? EV_PALETTE.crimson : EV_PALETTE.white
                  },
                  glyph(t.ic, t.x + 34, 152, t.on ? EV_PALETTE.white : EV_PALETTE.n4),
                  ...t.on ? [selectedCheck(t.x + 62, 124, at + 420)] : []
                ]
              }
            ]
          };
        }),
        sparkle(202, 96, 6, EV_PALETTE.amber),
        sparkle(572, 112, 5, EV_PALETTE.blush, idleDelay(2)),
        sparkle(548, 196, 4.5, EV_PALETTE.n4, idleDelay(1))
      ];
    }
  },
  /** Wizard step — image upload. Fans out once, then the upload sweep loops. */
  property_photography: {
    ...SIZE,
    dur: 1900,
    idle: true,
    nodes: () => photographyFan((left) => photoHorizon(left, true))
  },
  /**
   * Shown while photos upload and the listing is written. INDETERMINATE: no seal,
   * check or completion beat — the payoff belongs to `property_created`. `dur` is
   * the entrance window, never a run time.
   */
  property_creating: {
    ...SIZE,
    dur: 1e3,
    idle: true,
    indeterminate: true,
    nodes: () => {
      const stack = [
        { x: 226, rot: -8, fill: EV_PALETTE.n3, tint: EV_PALETTE.n3 },
        { x: 240, rot: -3, fill: EV_PALETTE.n2, tint: EV_PALETTE.n3 },
        { x: 254, rot: 2, fill: EV_PALETTE.white, tint: EV_PALETTE.n2 }
      ];
      const arch = "M456 214V175.3a44 44 0 0 1 88 0V214";
      return [
        shadow(385, 214, 172, 7, 60),
        {
          kind: "g",
          enter: { preset: "riseS", at: 60, dur: 560 },
          children: [
            { kind: "path", d: `${arch}Z`, fill: EV_PALETTE.n2 },
            {
              kind: "path",
              anim: { key: "breathe" },
              d: arch,
              fill: "none",
              stroke: EV_PALETTE.n3,
              strokeWidth: 2,
              strokeDasharray: [9, 8]
            },
            // Where a photo lands.
            {
              kind: "rect",
              x: 476,
              y: 143,
              width: 48,
              height: 35,
              rx: 8,
              fill: EV_PALETTE.white
            },
            {
              kind: "rect",
              anim: { key: "breathe" },
              x: 476,
              y: 143,
              width: 48,
              height: 35,
              rx: 8,
              fill: "none",
              stroke: EV_PALETTE.n3,
              strokeWidth: 2,
              strokeDasharray: [7, 6]
            },
            // Neutral, not crimson: crimson means settled, and this is not.
            { kind: "path", d: "M488 214v-22a12 12 0 0 1 24 0v22Z", fill: EV_PALETTE.n4 }
          ]
        },
        {
          kind: "g",
          enter: { preset: "riseS", at: 220, dur: 520 },
          children: stack.map((card) => ({
            kind: "g",
            transform: `rotate(${card.rot} ${card.x + 38} 178)`,
            children: photo(card.x, 146, 76, 64, card.fill, card.tint)
          }))
        },
        // Ferried on a loop, authored INVISIBLE: a paused or reduced-motion
        // reader must not see fake progress.
        ...[0, 1, 2].map((i) => ({
          kind: "g",
          anim: { key: "ferry", delay: i * EV_FERRY_STAGGER },
          opacity: 0,
          origin: [295, 176],
          children: photo(262, 150, 66, 52, EV_PALETTE.white, EV_PALETTE.n2)
        })),
        loaderTrack({ preset: "widen", at: 700, dur: 520 }),
        sparkle(222, 84, 6, EV_PALETTE.amber),
        sparkle(556, 96, 5, EV_PALETTE.blush, idleDelay(2)),
        sparkle(398, 68, 4.5, EV_PALETTE.n4, idleDelay(1))
      ];
    }
  },
  /** Wizard confirmation — the property is live. Plays once and settles. */
  property_created: {
    ...SIZE,
    dur: 2e3,
    idle: true,
    nodes: () => [
      shadow(380, 220, 148, 8, 60),
      {
        kind: "g",
        enter: { preset: "lift", at: 360, dur: 780 },
        children: [
          {
            kind: "g",
            enter: { preset: "rise", at: 60, dur: 580 },
            children: [
              {
                kind: "g",
                anim: { key: "floatS" },
                children: [
                  {
                    // Same join as property_animation — one building.
                    kind: "path",
                    d: "M312 130h136v80a6 6 0 0 1 -6 6h-124a6 6 0 0 1 -6 -6Z",
                    fill: EV_PALETTE.n2
                  },
                  // Base on the wall top, 8-unit eave.
                  { kind: "path", d: "M304 130 380 70l76 60Z", fill: EV_PALETTE.n3 },
                  {
                    kind: "rect",
                    x: 320,
                    y: 146,
                    width: 30,
                    height: 28,
                    rx: 5,
                    fill: EV_PALETTE.white
                  },
                  {
                    kind: "rect",
                    x: 410,
                    y: 146,
                    width: 30,
                    height: 28,
                    rx: 5,
                    fill: EV_PALETTE.white
                  },
                  {
                    kind: "path",
                    d: "M362 216v-30a18 18 0 0 1 36 0v30Z",
                    fill: EV_PALETTE.crimson
                  }
                ]
              }
            ]
          }
        ]
      },
      // From the house body, not the roof line; 0.9 so the burst fits the viewBox.
      ...confetti(380, 150, 780, 0.9),
      seal(454, 94, 30, 620),
      sparkle(226, 104, 7, EV_PALETTE.amber),
      sparkle(258, 172, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(556, 166, 6, EV_PALETTE.amber, idleDelay(1)),
      sparkle(588, 100, 4.5, EV_PALETTE.n4, idleDelay(3))
    ]
  },
  /** Wizard welcome — create a property group. Gathers once, then floats. */
  "property-groups-create": {
    ...SIZE,
    dur: 1900,
    idle: true,
    nodes: () => {
      const cards = [
        { x: 258, y: 116, at: 200 },
        { x: 344, y: 100, at: 360 },
        { x: 430, y: 116, at: 520 }
      ];
      return [
        shadow(380, 214, 166, 7, 60),
        {
          kind: "g",
          enter: { preset: "widen", at: 900, dur: 620 },
          origin: [380, 0],
          children: [
            {
              kind: "rect",
              x: 240,
              y: 196,
              width: 280,
              height: 9,
              rx: 4.5,
              fill: EV_PALETTE.n2
            },
            {
              kind: "rect",
              x: 368,
              y: 188,
              width: 24,
              height: 24,
              rx: 8,
              fill: EV_PALETTE.crimson
            },
            {
              kind: "path",
              d: "M374 200l4.4 4.6 8-8.6",
              fill: "none",
              stroke: EV_PALETTE.white,
              strokeWidth: 2.8,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ]
        },
        ...cards.map((c, i) => {
          const middle = i === 1;
          return {
            kind: "g",
            enter: { preset: "pop", at: c.at, dur: 500 },
            origin: [c.x + 36, c.y + 40],
            children: [
              {
                kind: "g",
                anim: {
                  key: middle ? "float" : "floatS",
                  delay: idleDelay(i)
                },
                children: [
                  {
                    kind: "rect",
                    x: c.x,
                    y: c.y,
                    width: 72,
                    height: 80,
                    rx: 12,
                    fill: EV_PALETTE.white
                  },
                  {
                    kind: "path",
                    d: `M${c.x + 10} ${c.y + 34} ${c.x + 36} ${c.y + 12} ${c.x + 62} ${c.y + 34}Z`,
                    fill: EV_PALETTE.n3
                  },
                  {
                    kind: "rect",
                    x: c.x + 16,
                    y: c.y + 32,
                    width: 40,
                    height: 30,
                    rx: 3,
                    fill: EV_PALETTE.n2
                  },
                  {
                    kind: "rect",
                    x: c.x + 30,
                    y: c.y + 44,
                    width: 12,
                    height: 18,
                    rx: 3,
                    fill: middle ? EV_PALETTE.crimson : EV_PALETTE.n4
                  },
                  bar2(c.x + 14, c.y + 68, 44, 6, EV_PALETTE.n2)
                ]
              }
            ]
          };
        }),
        sparkle(214, 92, 6, EV_PALETTE.amber),
        sparkle(564, 104, 5, EV_PALETTE.blush, idleDelay(2)),
        sparkle(584, 176, 4.5, EV_PALETTE.n4, idleDelay(1))
      ];
    }
  },
  /** Experience creation, first step. The GUIDE is the one crimson object. */
  experience_animation: {
    ...SIZE,
    dur: 1500,
    idle: true,
    nodes: () => [
      shadow(385, 220, 156, 8, 120),
      experienceLandmark({ preset: "grow", at: 240, dur: 560 }),
      // Painted before the guide (they stand behind); timings run the other way.
      ...EXPERIENCE_GUESTS.map(
        (guest, i) => experienceGuest(guest, { preset: "riseS", at: 620 + i * 170, dur: 460 })
      ),
      experienceGuide({ preset: "rise", at: 420, dur: 560 }),
      experiencePennant({ preset: "pop", at: 1e3, dur: 440 }),
      sun(548, 84, 15, 1220),
      sparkle(232, 96, 6, EV_PALETTE.amber),
      sparkle(566, 168, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(240, 176, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  },
  /** An experience's photographs: the property step's fan, new front picture. */
  experience_photography: {
    ...SIZE,
    dur: 1900,
    idle: true,
    nodes: () => photographyFan((left) => [
      { kind: "circle", cx: left + 26, cy: 132, r: 6, fill: EV_PALETTE.amber },
      {
        kind: "path",
        d: `M${left + 28} 172v-20a12 12 0 0 1 24 0v20Z`,
        fill: EV_PALETTE.n4,
        opacity: 0.8
      },
      {
        kind: "path",
        d: `M${left + 60} 172v-12a4.6 4.6 0 0 1 9.2 0v12Z`,
        fill: EV_PALETTE.n4,
        opacity: 0.8
      },
      { kind: "circle", cx: left + 64.6, cy: 152, r: 4, fill: EV_PALETTE.n4, opacity: 0.8 },
      {
        kind: "path",
        d: `M${left + 72} 172v-10a4.2 4.2 0 0 1 8.4 0v10Z`,
        fill: EV_PALETTE.n4,
        opacity: 0.8
      },
      { kind: "circle", cx: left + 76.2, cy: 154, r: 3.6, fill: EV_PALETTE.n4, opacity: 0.8 }
    ])
  },
  /**
   * `property_creating`'s twin with a schedule where the house was. INDETERMINATE:
   * no seal or check — the payoff is `experience_created`. `dur` is the entrance
   * window, never a run time.
   */
  experience_creating: {
    ...SIZE,
    dur: 1e3,
    idle: true,
    indeterminate: true,
    nodes: () => [
      shadow(388, 214, 180, 7, 120),
      {
        kind: "g",
        enter: { preset: "riseS", at: 60, dur: 560 },
        children: [
          // SOLID edge: a white card on a white page is invisible but still
          // notches the ground ellipse. Foot rests on the shadow's centre line.
          {
            kind: "rect",
            x: 442,
            y: 136,
            width: 122,
            height: 78,
            rx: 12,
            fill: EV_PALETTE.white,
            stroke: EV_PALETTE.n3,
            strokeWidth: 2
          },
          // The day is solid (it exists); the sessions on it are dashed.
          { kind: "rect", x: 458, y: 146, width: 40, height: 8, rx: 4, fill: EV_PALETTE.n2 },
          ...[164, 182, 200].map((y, i) => ({
            kind: "rect",
            anim: { key: "breathe", delay: idleDelay(i) },
            x: 458,
            y,
            width: 90,
            height: 10,
            rx: 5,
            fill: "none",
            stroke: EV_PALETTE.n3,
            strokeWidth: 2,
            strokeDasharray: [7, 6]
          }))
        ]
      },
      {
        kind: "g",
        enter: { preset: "riseS", at: 220, dur: 520 },
        children: EXPERIENCE_STACK.map((pill2) => ({
          kind: "g",
          transform: `rotate(${pill2.rot} ${pill2.x + 37} ${pill2.y + 10})`,
          children: slotPill(pill2.x, pill2.y, 74, 20, pill2.fill, pill2.dot, pill2.stroke)
        }))
      },
      // Ferried on a loop, authored INVISIBLE: no fake progress when paused.
      ...[0, 1, 2].map((i) => ({
        kind: "g",
        anim: { key: "ferry", delay: i * EV_FERRY_STAGGER },
        opacity: 0,
        origin: [281, 186],
        children: slotPill(244, 176, 74, 20, EV_PALETTE.white, EV_PALETTE.amber, EV_PALETTE.n3)
      })),
      loaderTrack({ preset: "widen", at: 700, dur: 520 }),
      sparkle(222, 84, 6, EV_PALETTE.amber),
      sparkle(556, 96, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(398, 68, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  },
  /**
   * `experience_animation`'s drawing at the SAME coordinates, lifted as one group.
   * Only lift, burst and seal may differ — a guide that moved is a bug.
   */
  experience_created: {
    ...SIZE,
    dur: 2e3,
    idle: true,
    nodes: () => [
      shadow(385, 220, 156, 8, 120),
      {
        kind: "g",
        enter: { preset: "lift", at: 360, dur: 780 },
        children: [
          {
            kind: "g",
            enter: { preset: "rise", at: 60, dur: 580 },
            children: [
              experienceLandmark(),
              ...EXPERIENCE_GUESTS.map((guest) => experienceGuest(guest)),
              experienceGuide(),
              experiencePennant()
            ]
          }
        ]
      },
      // From the group's body, never the landmark's tip; 0.9 to fit the box.
      ...confetti(390, 150, 780, 0.9),
      // Top-RIGHT corner — centred on the crown it reads as a lid on a jar.
      seal(516, 100, 28, 620),
      sparkle(226, 104, 7, EV_PALETTE.amber),
      sparkle(258, 176, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(556, 166, 6, EV_PALETTE.amber, idleDelay(1)),
      sparkle(588, 100, 4.5, EV_PALETTE.n4, idleDelay(3))
    ]
  },
  /**
   * Service creation, first step: a provider on a row of hours, one taken. Amber
   * touches the tick only; the provider is the only crimson.
   */
  service_animation: {
    ...SIZE,
    dur: 1500,
    idle: true,
    nodes: () => [
      shadow(385, 220, 156, 8, 120),
      serviceHours({ preset: "widen", at: 240, dur: 620 }),
      selectedCheck(466, 174, 620),
      serviceProvider({ preset: "rise", at: 460, dur: 560 }),
      serviceKit({ preset: "drop", at: 780, dur: 560 }),
      sun(548, 84, 15, 1180),
      sparkle(232, 100, 6, EV_PALETTE.amber),
      sparkle(566, 172, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(244, 172, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  },
  /** A service's photographs: the experience twin, front card shows the kit. */
  service_photography: {
    ...SIZE,
    dur: 1900,
    idle: true,
    nodes: () => photographyFan((left) => [
      { kind: "circle", cx: left + 26, cy: 132, r: 6, fill: EV_PALETTE.amber },
      {
        kind: "path",
        d: `M${left + 54} 146v-3a11 5 0 0 1 22 0v3`,
        fill: "none",
        stroke: EV_PALETTE.n4,
        strokeWidth: 3.4,
        strokeLinecap: "round",
        opacity: 0.8
      },
      {
        kind: "rect",
        x: left + 34,
        y: 146,
        width: 52,
        height: 26,
        rx: 5,
        fill: EV_PALETTE.n4,
        opacity: 0.8
      },
      {
        kind: "rect",
        x: left + 34,
        y: 156,
        width: 52,
        height: 2.5,
        fill: EV_PALETTE.white,
        opacity: 0.6
      },
      { kind: "rect", x: left + 53, y: 153, width: 10, height: 8, rx: 2, fill: EV_PALETTE.amber }
    ])
  },
  /**
   * `experience_creating`'s twin with the working-hours grid where the session card
   * was. INDETERMINATE: no seal, no check, no percentage.
   */
  service_creating: {
    ...SIZE,
    dur: 1e3,
    idle: true,
    indeterminate: true,
    nodes: () => [
      shadow(388, 214, 180, 7, 120),
      {
        kind: "g",
        enter: { preset: "riseS", at: 60, dur: 560 },
        children: [
          // Solid edge, foot on the ground line — see `experience_creating`.
          {
            kind: "rect",
            x: 412,
            y: 136,
            width: 152,
            height: 78,
            rx: 12,
            fill: EV_PALETTE.white,
            stroke: EV_PALETTE.n3,
            strokeWidth: 2
          },
          ...SERVICE_DAYS.map((x) => ({
            kind: "rect",
            x,
            y: 150,
            width: 22,
            height: 54,
            rx: 6,
            fill: EV_PALETTE.n2
          })),
          ...SERVICE_DAYS.map((x, i) => ({
            kind: "rect",
            anim: { key: "breathe", delay: idleDelay(i) },
            x,
            y: 150,
            width: 22,
            height: 54,
            rx: 6,
            fill: "none",
            stroke: EV_PALETTE.n3,
            strokeWidth: 2,
            strokeDasharray: [7, 6]
          }))
        ]
      },
      {
        kind: "g",
        enter: { preset: "riseS", at: 220, dur: 520 },
        children: SERVICE_STACK.map((block) => ({
          kind: "g",
          transform: `rotate(${block.rot} ${block.x + 18} ${block.y + 10})`,
          children: slotPill(
            block.x,
            block.y,
            36,
            20,
            block.fill,
            block.dot,
            block.stroke
          )
        }))
      },
      ...[0, 1, 2].map((i) => ({
        kind: "g",
        anim: { key: "ferry", delay: i * EV_FERRY_STAGGER },
        opacity: 0,
        origin: [254, 180],
        children: slotPill(236, 170, 36, 20, EV_PALETTE.white, EV_PALETTE.amber, EV_PALETTE.n3)
      })),
      loaderTrack({ preset: "widen", at: 700, dur: 520 }),
      sparkle(222, 84, 6, EV_PALETTE.amber),
      sparkle(556, 96, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(398, 68, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  },
  /**
   * `service_animation`'s drawing at the SAME coordinates, lifted as one group.
   * Only the lift, the burst and the seal may differ.
   */
  service_created: {
    ...SIZE,
    dur: 2e3,
    idle: true,
    nodes: () => [
      shadow(385, 220, 156, 8, 120),
      {
        kind: "g",
        enter: { preset: "lift", at: 360, dur: 780 },
        children: [
          {
            kind: "g",
            enter: { preset: "rise", at: 60, dur: 580 },
            children: [
              serviceHours(),
              selectedCheck(466, 174, 620),
              serviceProvider(),
              serviceKit()
            ]
          }
        ]
      },
      // From the provider's body, not the kit's handle.
      ...confetti(346, 152, 780, 0.9),
      seal(470, 96, 30, 620),
      sparkle(226, 104, 7, EV_PALETTE.amber),
      sparkle(258, 176, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(556, 166, 6, EV_PALETTE.amber, idleDelay(1)),
      sparkle(588, 100, 4.5, EV_PALETTE.n4, idleDelay(3))
    ]
  }
};

// src/events/boot.ts
var CX = 382;
var ARCH = { left: 322, right: 442, base: 206, shoulder: 124, r: 60 };
var ARCH_LEN = Math.ceil(2 * (ARCH.base - ARCH.shoulder) + Math.PI * ARCH.r);
var TRACK = { x: 322, y: 236, width: 120, height: 6 };
var SEGMENT_WIDTH = 40;
var EV_BOOT_SCENES = {
  app_boot: {
    x: 272,
    y: 48,
    width: 220,
    height: 200,
    dur: 980,
    idle: true,
    indeterminate: true,
    nodes: () => [
      shadow(CX, 214, 84, 7, 80),
      // The view through the doorway: two hills, the far one lighter.
      {
        kind: "g",
        enter: { preset: "riseS", at: 520 },
        children: [
          {
            kind: "path",
            d: "M327 206V174c20-12 40-14 62-6s34 8 48-2V206Z",
            fill: EV_PALETTE.n2
          },
          {
            kind: "path",
            d: "M327 206V190c24-10 52-12 80-2 12 4 22 4 30 0V206Z",
            fill: EV_PALETTE.n3
          }
        ]
      },
      sun(404, 118, 13, 760),
      // The subject: the arch, drawn in from one foot over the top to the other.
      {
        kind: "path",
        enter: { preset: "draw", at: 120, dur: 900, len: ARCH_LEN },
        d: `M${ARCH.left} ${ARCH.base}V${ARCH.shoulder}a${ARCH.r} ${ARCH.r} 0 0 1 ${ARCH.right - ARCH.left} 0V${ARCH.base}`,
        fill: "none",
        stroke: EV_PALETTE.crimson,
        strokeWidth: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: ARCH_LEN
      },
      {
        kind: "g",
        enter: { preset: "widen", at: 980, dur: 520 },
        origin: [CX, 0],
        children: [
          { kind: "rect", ...TRACK, rx: 3, fill: EV_PALETTE.n2 },
          {
            kind: "g",
            clip: { ...TRACK, rx: 3 },
            children: [
              {
                kind: "rect",
                anim: { key: "indet" },
                x: TRACK.x - SEGMENT_WIDTH - 6,
                y: TRACK.y,
                width: SEGMENT_WIDTH,
                height: TRACK.height,
                rx: 3,
                fill: EV_PALETTE.crimson
              }
            ]
          }
        ]
      }
    ]
  }
};

// src/events/chatParts.ts
var STAY = {
  place: { cx: 246, base: 142, r: 34 },
  pin: { cx: 56, cy: 112 },
  route: "M56 116C84 84 138 82 174 106s44 34 64 34",
  len: 240,
  /** The booked nights. Real structure — can later be driven by the actual stay length. */
  run: [3, 4, 5],
  /** The ONE status-token slot. Every token centres here. */
  slot: { cx: 284, cy: 44 },
  ground: { cx: 170, cy: 186, rx: 132 }
};
var S = STAY;
var NG = { x: 40, cw: 30, gap: 6, n: 7, y: 150, h: 26 };
var ncx = (i) => NG.x + i * (NG.cw + NG.gap);
var place = (tone, dashed = false) => {
  const { cx, base, r } = S.place;
  const door = tone === "confirmed" ? EV_PALETTE.crimson : EV_PALETTE.n4;
  const dw = r * 0.3;
  const dh = r * 0.55;
  const nodes = [
    {
      kind: "path",
      d: `M${cx - r} ${base}V${base - r * 0.88}a${r} ${r} 0 0 1 ${r * 2} 0V${base}Z`,
      fill: EV_PALETTE.n2
    },
    {
      kind: "path",
      d: `M${cx - dw} ${base}v-${dh}a${dw} ${dw} 0 0 1 ${dw * 2} 0v${dh}Z`,
      fill: door
    },
    {
      kind: "circle",
      cx: cx + dw * 0.55,
      cy: base - dh * 0.42,
      r: 2.2,
      fill: EV_PALETTE.white,
      opacity: 0.75
    }
  ];
  if (dashed) {
    nodes.push({
      kind: "path",
      d: `M${cx - r} ${base}V${base - r * 0.88}a${r} ${r} 0 0 1 ${r * 2} 0V${base}`,
      fill: "none",
      stroke: EV_PALETTE.n3,
      strokeWidth: 1.6,
      strokeDasharray: [7, 6]
    });
  }
  return nodes;
};
var pin = (tone, at = 180) => {
  const { cx, cy } = S.pin;
  const c = tone === "confirmed" ? EV_PALETTE.crimson : tone === "amber" ? EV_PALETTE.amber : EV_PALETTE.n4;
  const r = 13;
  return {
    kind: "g",
    enter: { preset: "drop", at, dur: 520 },
    origin: [cx, cy],
    children: [
      {
        kind: "path",
        fill: c,
        d: `M${cx} ${cy - r}a${r} ${r} 0 0 1 ${r} ${r}c0 ${r * 0.75}-${r} ${r * 1.7}-${r} ${r * 1.7}s-${r}-${r * 0.95}-${r}-${r * 1.7}a${r} ${r} 0 0 1 ${r}-${r}Z`
      },
      { kind: "circle", cx, cy, r: r * 0.36, fill: EV_PALETTE.white }
    ]
  };
};
var route = (tone, at = 420, dur = 760, partial = false) => {
  const c = tone === "confirmed" ? EV_PALETTE.crimson : tone === "amber" ? EV_PALETTE.amber : EV_PALETTE.n4;
  return [
    {
      kind: "path",
      d: S.route,
      fill: "none",
      stroke: EV_PALETTE.n2,
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeDasharray: [8, 8]
    },
    {
      kind: "path",
      enter: { preset: "draw", at, dur, len: S.len },
      d: S.route,
      fill: "none",
      stroke: c,
      strokeWidth: 3.4,
      strokeLinecap: "round",
      strokeDasharray: partial ? [S.len * 0.5, S.len] : S.len
    }
  ];
};
var nightsRoad = (run, tone, at, cellsEnter = true) => {
  const on = tone === "confirmed" ? EV_PALETTE.crimson : tone === "amber" ? EV_PALETTE.amberSoft : EV_PALETTE.n2;
  const ink = tone === "confirmed" ? EV_PALETTE.white : tone === "amber" ? EV_PALETTE.amber : EV_PALETTE.n4;
  const children = [];
  for (let i = 0; i < NG.n; i += 1) {
    const booked = run.includes(i);
    children.push({
      kind: "rect",
      x: ncx(i),
      y: NG.y,
      width: NG.cw,
      height: NG.h,
      rx: 8,
      fill: EV_PALETTE.white
    });
    if (booked) {
      const lit = [
        { kind: "rect", x: ncx(i), y: NG.y, width: NG.cw, height: NG.h, rx: 8, fill: on },
        bar2(ncx(i) + 9, NG.y + 9.5, 12, 7, ink)
      ];
      children.push(
        cellsEnter ? {
          kind: "g",
          enter: { preset: "pop", at: at + run.indexOf(i) * 140, dur: 420 },
          origin: [ncx(i) + NG.cw / 2, NG.y + NG.h / 2],
          children: lit
        } : { kind: "g", children: lit }
      );
    } else {
      children.push(bar2(ncx(i) + 10, NG.y + 10, 10, 6, EV_PALETTE.n2));
    }
  }
  return { kind: "g", children };
};
var nightsSwap = (from, to, at) => [
  {
    kind: "g",
    opacity: 0,
    enter: { preset: "swap", at: at - 460, dur: 880 },
    children: [nightsRoad(from, "amber", 0, false)]
  },
  {
    kind: "g",
    enter: { preset: "inR", at: at + 360, dur: 520 },
    children: [nightsRoad(to, "amber", at + 360, false)]
  }
];
var key = (cx, cy, at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 480 },
  origin: [cx, cy],
  children: [
    { kind: "circle", cx, cy, r: 11, fill: "none", stroke: EV_PALETTE.crimson, strokeWidth: 4.5 },
    { kind: "rect", x: cx - 2.2, y: cy + 8, width: 4.6, height: 22, rx: 2.3, fill: EV_PALETTE.crimson },
    { kind: "rect", x: cx + 2, y: cy + 16, width: 8, height: 4, rx: 2, fill: EV_PALETTE.crimson },
    { kind: "rect", x: cx + 2, y: cy + 23, width: 6, height: 4, rx: 2, fill: EV_PALETTE.crimson }
  ]
});
var pill = (fill, at, w, children) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 420 },
  origin: [S.slot.cx, S.slot.cy],
  children: [
    {
      kind: "rect",
      x: S.slot.cx - w / 2,
      y: S.slot.cy - 14,
      width: w,
      height: 28,
      rx: 14,
      fill
    },
    ...children
  ]
});
var doubleCheck = (x, y, c) => ({
  kind: "g",
  fill: "none",
  stroke: c,
  strokeWidth: 2.1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [
    { kind: "path", d: `M${x} ${y}l2.8 3 6-6.6` },
    { kind: "path", d: `M${x + 6.5} ${y}l2.8 3 6-6.6` }
  ]
});
var pendingToken = (at = 900) => pill(EV_PALETTE.amberSoft, at, 70, [
  {
    kind: "circle",
    anim: { key: "pending" },
    cx: S.slot.cx - 17,
    cy: S.slot.cy,
    r: 5,
    fill: EV_PALETTE.amber
  },
  bar2(S.slot.cx - 5, S.slot.cy - 3.5, 28, 7, EV_PALETTE.amber)
]);
var sentToken = (at = 900, tone = "neutral") => {
  const fill = tone === "amber" ? EV_PALETTE.amberSoft : EV_PALETTE.n2;
  const ink = tone === "amber" ? EV_PALETTE.amber : EV_PALETTE.n4;
  return pill(fill, at, 74, [
    doubleCheck(S.slot.cx - 25, S.slot.cy, ink),
    bar2(S.slot.cx - 5, S.slot.cy - 3.5, 30, 7, ink)
  ]);
};
var crossToken = (at = 900, r = 18) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 460 },
  origin: [S.slot.cx, S.slot.cy],
  children: [
    { kind: "circle", cx: S.slot.cx, cy: S.slot.cy, r, fill: EV_PALETTE.n4 },
    {
      kind: "path",
      d: `M${S.slot.cx - 7} ${S.slot.cy - 7}l14 14M${S.slot.cx + 7} ${S.slot.cy - 7}l-14 14`,
      fill: "none",
      stroke: EV_PALETTE.white,
      strokeWidth: 3.4,
      strokeLinecap: "round"
    }
  ]
});
var sealToken = (at = 900) => seal(S.slot.cx, S.slot.cy, 22, at);
var tagToken = (at = 900) => {
  const { cx, cy } = S.slot;
  return {
    kind: "g",
    enter: { preset: "pop", at, dur: 480 },
    origin: [cx, cy],
    children: [
      {
        kind: "g",
        anim: { key: "float" },
        children: [
          {
            kind: "path",
            d: `M${cx - 14} ${cy - 18}h30a12 12 0 0 1 12 12v12a12 12 0 0 1 -12 12h-30l-14-18Z`,
            fill: EV_PALETTE.amber
          },
          { kind: "circle", cx: cx - 16, cy, r: 4.6, fill: EV_PALETTE.white, opacity: 0.85 },
          bar2(cx - 4, cy - 3.5, 26, 7, EV_PALETTE.white)
        ]
      }
    ]
  };
};
var reviewToken = (at = 900) => pill(EV_PALETTE.crimsonSoft, at, 70, [
  { kind: "circle", cx: S.slot.cx - 17, cy: S.slot.cy, r: 5, fill: EV_PALETTE.crimson },
  bar2(S.slot.cx - 5, S.slot.cy - 3.5, 28, 7, EV_PALETTE.crimson)
]);
var documentToken = (at = 900) => {
  const { cx, cy } = S.slot;
  return {
    kind: "g",
    enter: { preset: "pop", at, dur: 460 },
    origin: [cx, cy],
    children: [
      { kind: "rect", x: cx - 22, y: cy - 15, width: 40, height: 30, rx: 5, fill: EV_PALETTE.n4 },
      { kind: "circle", cx: cx - 12, cy: cy - 4, r: 4.2, fill: EV_PALETTE.white },
      bar2(cx - 19, cy + 5, 20, 3.4, EV_PALETTE.white),
      bar2(cx - 3, cy - 7, 13, 3.4, EV_PALETTE.white),
      // Stops a full unit short of the shield (left edge x = cx+6 at y = cy+1).
      // At 13 the shield clips it; at 9 the two are tangent and blur together at
      // half scale. Unequal line lengths also read more like text.
      bar2(cx - 3, cy - 1, 8, 3.4, EV_PALETTE.white),
      {
        kind: "path",
        d: `M${cx + 14} ${cy - 2}l8 3v5.6a9 9 0 0 1 -8 8.4a9 9 0 0 1 -8 -8.4v-5.6Z`,
        fill: EV_PALETTE.crimson
      }
    ]
  };
};
var stay = ({
  tone,
  dashed = false,
  routeAt = 420,
  routeDur = 780,
  partial = false,
  run = S.run,
  nightsAt = 760,
  lift: lift2,
  nightsOverride,
  pinPending = false
}) => {
  const property = {
    kind: "g",
    enter: { preset: "riseS", at: 60, dur: 560 },
    children: [{ kind: "g", anim: { key: "floatS" }, children: place(tone, dashed) }]
  };
  const pinNode = pin(tone === "confirmed" ? "confirmed" : tone === "muted" ? "muted" : "amber");
  return [
    shadowOfStay(),
    lift2 === void 0 ? property : { kind: "g", enter: { preset: "lift", at: lift2, dur: 780 }, children: [property] },
    ...nightsOverride ?? [nightsRoad(run, tone, nightsAt)],
    ...route(tone, routeAt, routeDur, partial),
    pinPending ? { kind: "g", anim: { key: "pending" }, children: [pinNode] } : pinNode
  ];
};
var shadowOfStay = () => ({
  kind: "ellipse",
  enter: { preset: "pop", at: 60, dur: 520 },
  origin: [S.ground.cx, S.ground.cy],
  cx: S.ground.cx,
  cy: S.ground.cy,
  rx: S.ground.rx,
  ry: 6,
  fill: EV_PALETTE.ground
});

// src/events/chat.ts
var SIZE2 = { width: 340, height: 200 };
var envelope = (at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 480 },
  origin: [56, 76],
  children: [
    { kind: "rect", x: 36, y: 60, width: 40, height: 30, rx: 6, fill: EV_PALETTE.amber },
    {
      kind: "path",
      d: "M36 64l20 15 20-15",
      fill: "none",
      stroke: EV_PALETTE.white,
      strokeWidth: 2.6,
      strokeLinejoin: "round"
    }
  ]
});
var discountMark = (at) => ({
  kind: "g",
  enter: { preset: "pop", at, dur: 480 },
  origin: [246, 118],
  children: [
    {
      kind: "g",
      anim: { key: "floatS" },
      children: [
        { kind: "rect", x: 228, y: 104, width: 36, height: 26, rx: 8, fill: EV_PALETTE.amber },
        {
          kind: "rect",
          x: 236,
          y: 113.5,
          width: 20,
          height: 7,
          rx: 3.5,
          fill: EV_PALETTE.white
        }
      ]
    }
  ]
});
var stars = () => [0, 1, 2, 3, 4].map((i) => ({
  kind: "g",
  enter: { preset: "pop", at: 1120 + i * 130, dur: 420 },
  origin: [118 + i * 34, 66],
  children: [star5(118 + i * 34, 66, 13, i === 0 ? EV_PALETTE.crimson : EV_PALETTE.n3, i === 0)]
}));
var muted = (children) => [
  { kind: "g", opacity: EV_MUTED_OPACITY, children }
];
var EV_CHAT_SCENES = {
  /** A guest has requested a stay. */
  BookingRequest: {
    ...SIZE2,
    dur: 1600,
    idle: true,
    nodes: () => [
      ...stay({ tone: "amber", dashed: true, partial: true, routeDur: 720, nightsAt: 620 }),
      pendingToken(900),
      sparkle(24, 110, 5, EV_PALETTE.n3)
    ]
  },
  /** You sent a request; waiting on a reply. Same gesture, in neutrals. */
  BookingRequestSent: {
    ...SIZE2,
    dur: 1600,
    idle: true,
    nodes: () => [
      ...stay({ tone: "plain", dashed: true, partial: true, routeDur: 720, nightsAt: 620 }),
      sentToken(900),
      sparkle(24, 110, 5, EV_PALETTE.n3)
    ]
  },
  /**
   * A host invited YOU to book — the receiving half of `BookingInvitationSent`: the
   * same drawing, but the amber pending token, because the answer is yours to give.
   */
  BookingInvitation: {
    ...SIZE2,
    dur: 1700,
    idle: true,
    nodes: () => [
      ...stay({ tone: "amber", dashed: true, partial: true, routeDur: 720, nightsAt: 620 }),
      envelope(1060),
      pendingToken(900),
      sparkle(122, 40, 4.5, EV_PALETTE.blush, 900)
    ]
  },
  /** You invited a guest to book. */
  BookingInvitationSent: {
    ...SIZE2,
    dur: 1700,
    idle: true,
    nodes: () => [
      ...stay({ tone: "plain", dashed: true, partial: true, routeDur: 720, nightsAt: 620 }),
      envelope(1060),
      sentToken(900, "amber"),
      sparkle(122, 40, 4.5, EV_PALETTE.blush, 900)
    ]
  },
  /** The guest wants to change the dates. The nights moving IS the message. */
  BookingModification: {
    ...SIZE2,
    dur: 2e3,
    idle: true,
    nodes: () => [
      ...stay({
        tone: "amber",
        dashed: true,
        partial: true,
        routeDur: 720,
        pinPending: true,
        nightsOverride: nightsSwap([1, 2, 3], STAY.run, 880)
      }),
      pendingToken(900),
      sparkle(24, 110, 5, EV_PALETTE.amber)
    ]
  },
  /** You proposed new dates. */
  BookingModificationSent: {
    ...SIZE2,
    dur: 2e3,
    idle: true,
    nodes: () => [
      ...stay({
        tone: "plain",
        dashed: true,
        partial: true,
        routeDur: 720,
        nightsOverride: nightsSwap([1, 2, 3], STAY.run, 880)
      }),
      sentToken(900)
    ]
  },
  /** The stay is confirmed. The emotional peak of the set. */
  BookingConfirmed: {
    ...SIZE2,
    dur: 2300,
    idle: true,
    nodes: () => [
      ...stay({ tone: "confirmed", routeDur: 820, nightsAt: 760, lift: 1e3 }),
      key(300, 104, 1180),
      sealToken(900),
      ...confetti(180, 104, 1240, 0.95),
      sun(92, 40, 12, 1340),
      sparkle(140, 36, 5, EV_PALETTE.blush, 900),
      sparkle(24, 166, 4.5, EV_PALETTE.amber, 450)
    ]
  },
  /**
   * Your request was declined: the route stops half-drawn, NO nights light (they never
   * happened) and there is no idle loop.
   */
  BookingRejection: {
    ...SIZE2,
    dur: 1500,
    idle: false,
    nodes: () => muted([
      ...stay({
        tone: "muted",
        dashed: true,
        partial: true,
        routeDur: 560,
        run: []
      }),
      crossToken(900)
    ])
  },
  /** You declined a request. The quietest piece in the set. */
  BookingRejectionSent: {
    ...SIZE2,
    dur: 1500,
    idle: false,
    nodes: () => muted([
      ...stay({
        tone: "muted",
        dashed: true,
        partial: true,
        routeDur: 560,
        run: []
      }),
      crossToken(900),
      {
        kind: "g",
        enter: { preset: "pop", at: 1160, dur: 380 },
        origin: [STAY.slot.cx, 78],
        children: [doubleCheck(STAY.slot.cx - 8, 78, EV_PALETTE.n4)]
      }
    ])
  },
  /** You offered the guest a discounted stay. */
  SpecialOffer: {
    ...SIZE2,
    dur: 1900,
    idle: true,
    nodes: () => [
      ...stay({ tone: "amber", dashed: true, partial: true, routeDur: 720, nightsAt: 760 }),
      discountMark(1120),
      tagToken(900),
      sparkle(24, 62, 6, EV_PALETTE.amber),
      sparkle(134, 38, 4.5, EV_PALETTE.blush, 900),
      sparkle(322, 158, 5, EV_PALETTE.amber, 450)
    ]
  },
  /** After checkout, asking the guest for a review. */
  ReviewRequest: {
    ...SIZE2,
    dur: 2e3,
    idle: true,
    nodes: () => [
      ...stay({ tone: "confirmed", routeDur: 780, nightsAt: 700 }),
      ...stars(),
      sparkle(24, 166, 4.5, EV_PALETTE.amber, 450),
      reviewToken(900)
    ]
  },
  /**
   * A guest shared an ID for somebody travelling with them. The only piece with no
   * sparkle, confetti or lift — holding somebody else's passport is a duty, not an
   * occasion, so the token alone carries the meaning.
   */
  GuestDocumentShared: {
    ...SIZE2,
    dur: 1800,
    idle: true,
    nodes: () => [
      ...stay({ tone: "confirmed", routeDur: 760, nightsAt: 700 }),
      documentToken(900)
    ]
  }
};

// src/events/icons.ts
var SIZE3 = 96;
var INK = "currentColor";
var STROKE = 6.8;
var line = (d, enter, origin) => ({
  kind: "path",
  d,
  fill: "none",
  stroke: INK,
  strokeWidth: STROKE,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  enter,
  origin
});
var HOUSE = "M14.4 81.6V47.6a33.6 33.6 0 0 1 67.2 0v34Z";
var DOOR = "M41.2 81.6v-14.8a6.8 6.8 0 0 1 13.6 0v14.8";
var PEAK_BIG = "M11.2 76.8 39.2 34.4 67.2 76.8Z";
var PEAK_FAR = "M53.6 76.8 68 54.4 82.4 76.8";
var STEM = "M48 33.6V26.8";
var DOME = "M19.2 62.8a28.8 28.8 0 0 1 57.6 0Z";
var TRAY = "M15.6 72.8h64.8";
var BELL = [48, 62.8];
var ring = (d, at) => ({
  kind: "path",
  d,
  fill: "none",
  stroke: EV_PALETTE.amber,
  strokeWidth: 5,
  strokeLinecap: "round",
  enter: { preset: "pop", at, dur: 380 },
  origin: BELL
});
var EV_ICON_SCENES = {
  /** The house hops once, its doorway lights amber, a spark over the roof. */
  icon_stays: {
    width: SIZE3,
    height: SIZE3,
    dur: 320,
    idle: false,
    nodes: () => [
      {
        kind: "g",
        enter: { preset: "lift", at: 0, dur: 520 },
        children: [
          // Under the strokes, so the outline stays crisp over the fill.
          {
            kind: "path",
            d: `${DOOR}Z`,
            fill: EV_PALETTE.amber,
            enter: { preset: "pop", at: 180 },
            origin: [48, 74]
          },
          line(HOUSE),
          line(DOOR)
        ]
      },
      sparkPop(84, 22, 6, EV_PALETTE.amber, 320)
    ]
  },
  /** The sun rises behind the ridge, the peaks hop, a spark in the morning sky. */
  icon_experiences: {
    width: SIZE3,
    height: SIZE3,
    dur: 380,
    idle: false,
    nodes: () => [
      {
        kind: "circle",
        cx: 69.6,
        cy: 26.4,
        r: 8.8,
        fill: EV_PALETTE.amber,
        enter: { preset: "riseS", at: 200 }
      },
      {
        kind: "g",
        enter: { preset: "lift", at: 0, dur: 520 },
        children: [line(PEAK_BIG), line(PEAK_FAR)]
      },
      sparkPop(20, 28, 5, EV_PALETTE.amber, 380)
    ]
  },
  /** The tray slides open, the bell is tapped and rattles, two rings sound out of it. */
  icon_services: {
    width: SIZE3,
    height: SIZE3,
    dur: 340,
    idle: false,
    nodes: () => [
      line(TRAY, { preset: "widen", at: 0 }, [48, 72.8]),
      {
        kind: "g",
        enter: { preset: "rattle", at: 60 },
        origin: BELL,
        children: [line(STEM), line(DOME)]
      },
      ring("M68.6 33.3A36 36 0 0 1 82.8 53.5", 240),
      ring("M72.7 27.6A43 43 0 0 1 89.5 51.7", 340)
    ]
  }
};

// src/events/navIcons.ts
var SIZE4 = 96;
var INK2 = "currentColor";
var STROKE2 = 6.8;
var line2 = (d, enter, origin) => ({
  kind: "path",
  d,
  fill: "none",
  stroke: INK2,
  strokeWidth: STROKE2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  enter,
  origin
});
var lift = (children) => ({
  kind: "g",
  enter: { preset: "lift", at: 0, dur: 520 },
  children
});
var HOUSE2 = "M12 81.6V46L48 14.4 84 46v35.6Z";
var DOOR2 = "M41.2 81.6v-14.8a6.8 6.8 0 0 1 13.6 0v14.8";
var calendarFrame = () => [
  {
    kind: "rect",
    x: 14,
    y: 22,
    width: 68,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: INK2,
    strokeWidth: STROKE2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  line2("M32 14v14"),
  line2("M64 14v14"),
  line2("M14 40h68")
];
var BUBBLE = "M26 18h44a10 10 0 0 1 10 10v30a10 10 0 0 1-10 10H44L28 82V68h-2a10 10 0 0 1-10-10V28a10 10 0 0 1 10-10Z";
var dot = (cx, cy) => ({
  kind: "circle",
  cx,
  cy,
  r: 3.4,
  fill: INK2
});
var EV_NAV_SCENES = {
  /** The house hops, its doorway lights amber. */
  nav_home: {
    width: SIZE4,
    height: SIZE4,
    dur: 320,
    idle: false,
    nodes: () => [
      lift([
        {
          kind: "path",
          d: `${DOOR2}Z`,
          fill: EV_PALETTE.amber,
          enter: { preset: "pop", at: 180 },
          origin: [48, 74]
        },
        line2(HOUSE2),
        line2(DOOR2)
      ])
    ]
  },
  /** The page hops, an amber check lands on it — a trip that is booked. */
  nav_trips: {
    width: SIZE4,
    height: SIZE4,
    dur: 320,
    idle: false,
    nodes: () => [
      lift([
        ...calendarFrame(),
        {
          kind: "path",
          d: "M31 59l11 10 22-21",
          fill: "none",
          stroke: EV_PALETTE.amber,
          strokeWidth: 5.6,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          enter: { preset: "pop", at: 180 },
          origin: [48, 60]
        }
      ])
    ]
  },
  /** The page hops, the booked night fills amber. */
  nav_bookings: {
    width: SIZE4,
    height: SIZE4,
    dur: 320,
    idle: false,
    nodes: () => [
      lift([
        {
          kind: "rect",
          x: 26.4,
          y: 49,
          width: 15.2,
          height: 15,
          rx: 3.4,
          fill: EV_PALETTE.amber,
          enter: { preset: "pop", at: 180 },
          origin: [34, 56.5]
        },
        ...calendarFrame(),
        dot(56, 57),
        dot(68, 57),
        dot(34, 70),
        dot(46, 70)
      ])
    ]
  },
  /** The bubble hops, two lines of text, a spark off its corner. */
  nav_messages: {
    width: SIZE4,
    height: SIZE4,
    dur: 380,
    idle: false,
    nodes: () => [
      lift([line2(BUBBLE), line2("M32 36h32"), line2("M32 50h20")]),
      sparkPop(86, 12, 6, EV_PALETTE.amber, 320)
    ]
  },
  /** The head hops and fills amber inside its ring. */
  nav_account: {
    width: SIZE4,
    height: SIZE4,
    dur: 320,
    idle: false,
    nodes: () => [
      lift([
        {
          kind: "circle",
          cx: 48,
          cy: 40,
          r: 10,
          fill: EV_PALETTE.amber,
          enter: { preset: "pop", at: 180 },
          origin: [48, 40]
        },
        {
          kind: "circle",
          cx: 48,
          cy: 48,
          r: 34,
          fill: "none",
          stroke: INK2,
          strokeWidth: STROKE2
        },
        {
          kind: "circle",
          cx: 48,
          cy: 40,
          r: 10,
          fill: "none",
          stroke: INK2,
          strokeWidth: STROKE2
        },
        line2("M28 72a20 14 0 0 1 40 0")
      ])
    ]
  },
  /** The lens hops, a glint catches in it. */
  nav_search: {
    width: SIZE4,
    height: SIZE4,
    dur: 320,
    idle: false,
    nodes: () => [
      lift([
        {
          kind: "circle",
          cx: 40,
          cy: 40,
          r: 28,
          fill: "none",
          stroke: INK2,
          strokeWidth: STROKE2
        },
        line2("M60 60l24 24"),
        {
          kind: "path",
          d: "M27 38a14 14 0 0 1 11-11",
          fill: "none",
          stroke: EV_PALETTE.amber,
          strokeWidth: 5,
          strokeLinecap: "round",
          enter: { preset: "pop", at: 180 },
          origin: [40, 40]
        }
      ])
    ]
  }
};

// src/events/status.ts
var EV_STATUS_SCENES = {
  /** Onboarding complete, and the property-group wizard's success step. */
  success_check: {
    width: 200,
    height: 170,
    dur: 1e3,
    idle: true,
    nodes: () => [
      seal(100, 85, 48, 180),
      ...confetti(100, 85, 420, 0.6),
      sparkle(26, 40, 6, EV_PALETTE.amber),
      sparkle(172, 132, 5, EV_PALETTE.blush, idleDelay(2)),
      sparkle(40, 138, 4.5, EV_PALETTE.n4, idleDelay(1))
    ]
  }
};

// src/events/scenes.ts
var EV_SCENES = {
  ...EV_CHAT_SCENES,
  ...EV_BANNER_SCENES,
  ...EV_STATUS_SCENES,
  ...EV_BOOT_SCENES,
  ...EV_ICON_SCENES,
  ...EV_NAV_SCENES
};
var EV_CHAT_NAMES = Object.keys(EV_CHAT_SCENES);
var EV_BANNER_NAMES = Object.keys(EV_BANNER_SCENES);
var EV_STATUS_NAMES = Object.keys(EV_STATUS_SCENES);
var EV_BOOT_NAMES = Object.keys(EV_BOOT_SCENES);
var EV_ICON_NAMES = Object.keys(EV_ICON_SCENES);
var EV_NAV_NAMES = Object.keys(EV_NAV_SCENES);
var EV_ALIASES = {
  BookingRequestChatArtifact: "BookingRequest",
  BookingConfirmedChatArtifact: "BookingConfirmed"
};
var resolveEventName = (name) => name in EV_ALIASES ? EV_ALIASES[name] : name;
var resolveEventScene = (name) => EV_SCENES[resolveEventName(name)];
var evSceneAspect = (name) => {
  const scene = resolveEventScene(name);
  return scene.width / scene.height;
};
var END_CACHE = /* @__PURE__ */ new Map();
var lastCueEnd = (nodes) => nodes.reduce((end, node) => {
  const cue = node.enter;
  const own = cue ? cue.at + (cue.dur ?? EV_ENTER[cue.preset].dur) : 0;
  const kids = node.kind === "g" ? lastCueEnd(node.children) : 0;
  return Math.max(end, own, kids);
}, 0);
var evSceneEnd = (name) => {
  const cached = END_CACHE.get(name);
  if (cached !== void 0) return cached;
  const scene = EV_SCENES[name];
  const end = Math.max(scene.dur, lastCueEnd(scene.nodes())) + EV_PLAY_TAIL;
  END_CACHE.set(name, end);
  return end;
};

// src/events/webKeyframes.ts
var EV_WEB_ENTER_KEYFRAMES = {
  rise: `
        from { opacity: 0; transform: translateY(26px); }
        to { opacity: 1; transform: none; }
    `,
  riseS: `
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: none; }
    `,
  drop: `
        from { opacity: 0; transform: translateY(-38px); }
        to { opacity: 1; transform: none; }
    `,
  pop: `
        from { opacity: 0; transform: scale(0.35); }
        to { opacity: 1; transform: none; }
    `,
  inR: `
        from { opacity: 0; transform: translateX(34px); }
        to { opacity: 1; transform: none; }
    `,
  seal: `
        0% { opacity: 0; transform: scale(2.4) rotate(-22deg); }
        60% { opacity: 1; }
        100% { opacity: 1; transform: none; }
    `,
  // Direction, rotation and distance are per-piece custom properties, so all sixteen
  // confetti pieces share one keyframe set.
  burst: `
        0% { opacity: 0; transform: translate(0, 0) scale(0.3) rotate(0); }
        14% { opacity: 1; }
        68% { opacity: 1; }
        100% {
            opacity: 0;
            transform: translate(var(--tx), var(--ty)) scale(1) rotate(var(--rot));
        }
    `,
  grow: `
        from { transform: scaleY(0); }
        to { transform: none; }
    `,
  widen: `
        from { transform: scaleX(0); }
        to { transform: none; }
    `,
  draw: `
        from { stroke-dashoffset: var(--len); }
        to { stroke-dashoffset: 0; }
    `,
  lift: `
        0% { transform: translateY(0); }
        55% { transform: translateY(-7px); }
        100% { transform: none; }
    `,
  fan: `
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: none; }
    `,
  // Appear, hold, leave — one cue for a whole transient element. It rests invisible,
  // which is why the old date range does not snap back when the sequence ends.
  swap: `
        0% { opacity: 0; transform: none; }
        18% { opacity: 1; }
        62% { opacity: 1; transform: none; }
        100% { opacity: 0; transform: translateX(-16px); }
    `,
  // A tapped bell: four diminishing swings about the node's own origin, resting unrotated.
  rattle: `
        0% { transform: none; }
        20% { transform: rotate(-12deg); }
        45% { transform: rotate(9deg); }
        70% { transform: rotate(-5deg); }
        100% { transform: none; }
    `
};
var EV_WEB_IDLE_KEYFRAMES = {
  float: `
        0%, 100% { transform: none; }
        50% { transform: translateY(-3.5px); }
    `,
  floatS: `
        0%, 100% { transform: none; }
        50% { transform: translateY(-2px); }
    `,
  twinkle: `
        0%, 100% { opacity: 0.35; transform: scale(0.86); }
        50% { opacity: 1; transform: none; }
    `,
  pending: `
        0%, 100% { opacity: 1; }
        50% { opacity: 0.32; }
    `,
  spin: `
        to { transform: rotate(360deg); }
    `,
  sway: `
        0%, 100% { transform: rotate(-3deg); }
        50% { transform: rotate(3deg); }
    `,
  shimmer: `
        0% { opacity: 0; }
        40% { opacity: 0.5; }
        100% { opacity: 0; }
    `,
  // A photo carried from the stack into the property's frame. Full opacity until 94% of
  // the travel so it visibly REACHES the frame before dissolving — shorten that and the
  // photos dissolve at the edge instead of landing in it.
  ferry: `
        0% { opacity: 0; transform: translate(0, 0) scale(0.84) rotate(-9deg); }
        14% { opacity: 1; }
        52% { transform: translate(102px, -50px) scale(1) rotate(0); }
        94% { opacity: 1; transform: translate(205px, -16px) scale(0.66) rotate(6deg); }
        100% { opacity: 0; transform: translate(212px, -14px) scale(0.62) rotate(7deg); }
    `,
  // Starts and ends outside its track, and is clipped back to it, so the resting frame
  // shows an empty track rather than a bar parked at some percentage.
  indet: `
        from { transform: translateX(0); }
        to { transform: translateX(250px); }
    `,
  breathe: `
        0%, 100% { opacity: 0.5; }
        50% { opacity: 1; }
    `
};

// src/events/staticScene.ts
var KEYFRAME_PREFIX = "maat-ev-";
var escapeAttr = (value) => String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
var bezier = (key2) => `cubic-bezier(${EV_EASING[key2].join(",")})`;
var cueStyle = (node) => {
  const style = [];
  if (node.enter) {
    const { preset, at, dur, tx, ty, rot, len } = node.enter;
    style.push(`--t:${at}ms`);
    if (dur !== void 0 && dur !== EV_ENTER[preset].dur) style.push(`--d:${dur}ms`);
    if (tx !== void 0) style.push(`--tx:${tx}px`);
    if (ty !== void 0) style.push(`--ty:${ty}px`);
    if (rot !== void 0) style.push(`--rot:${rot}deg`);
    if (len !== void 0) style.push(`--len:${len}`);
  }
  if (node.anim?.delay) style.push(`--dl:${node.anim.delay}ms`);
  if (node.origin) style.push(`transform-origin:${node.origin[0]}px ${node.origin[1]}px`);
  return style.length ? style.join(";") : void 0;
};
var sharedAttrs = (node) => [
  ["fill", node.fill],
  ["opacity", node.opacity],
  ["transform", node.transform],
  ["stroke", node.stroke],
  ["stroke-width", node.strokeWidth],
  ["stroke-linecap", node.strokeLinecap],
  ["stroke-linejoin", node.strokeLinejoin],
  [
    "stroke-dasharray",
    typeof node.strokeDasharray === "object" ? node.strokeDasharray.join(" ") : node.strokeDasharray
  ],
  ["stroke-dashoffset", node.strokeDashoffset],
  [
    "class",
    [node.enter && `e-${node.enter.preset}`, node.anim && `i-${node.anim.key}`].filter(Boolean).join(" ") || void 0
  ],
  ["style", cueStyle(node)]
];
var attrs = (pairs) => pairs.filter((pair) => pair[1] !== void 0).map(([key2, value]) => ` ${key2}="${escapeAttr(value)}"`).join("");
var renderNode = (node, idPrefix, path) => {
  const shared = sharedAttrs(node);
  switch (node.kind) {
    case "path":
      return `<path${attrs([...shared, ["d", node.d]])}/>`;
    case "rect":
      return `<rect${attrs([
        ...shared,
        ["x", node.x],
        ["y", node.y],
        ["width", node.width],
        ["height", node.height],
        ["rx", node.rx]
      ])}/>`;
    case "circle":
      return `<circle${attrs([...shared, ["cx", node.cx], ["cy", node.cy], ["r", node.r]])}/>`;
    case "ellipse":
      return `<ellipse${attrs([
        ...shared,
        ["cx", node.cx],
        ["cy", node.cy],
        ["rx", node.rx],
        ["ry", node.ry]
      ])}/>`;
    case "g": {
      const kids = node.children.map((child, i) => renderNode(child, idPrefix, `${path}-${i}`)).join("");
      if (!node.clip) return `<g${attrs(shared)}>${kids}</g>`;
      const clipId = `${idPrefix}${path}`;
      const { x, y, width, height, rx } = node.clip;
      return `<g${attrs(shared)}><defs><clipPath id="${clipId}"><rect${attrs([
        ["x", x],
        ["y", y],
        ["width", width],
        ["height", height],
        ["rx", rx]
      ])}/></clipPath></defs><g clip-path="url(#${clipId})">${kids}</g></g>`;
    }
    default:
      return "";
  }
};
function eventSceneToStaticSvg(name, { className, idPrefix = "evs" }) {
  const scene = resolveEventScene(name);
  const viewBox = `${scene.x ?? 0} ${scene.y ?? 0} ${scene.width} ${scene.height}`;
  const classes = [className, "pl", scene.idle ? "id" : void 0].filter(Boolean).join(" ");
  const body = scene.nodes().map((node, i) => renderNode(node, idPrefix, `-${i}`)).join("");
  return `<svg class="${classes}" viewBox="${viewBox}" aria-hidden="true" focusable="false">${body}</svg>`;
}
var collectCues = (nodes, enters, idles) => {
  for (const node of nodes) {
    if (node.enter) enters.add(node.enter.preset);
    if (node.anim) idles.add(node.anim.key);
    if (node.kind === "g") collectCues(node.children, enters, idles);
  }
};
function eventSceneStaticCss(name, className) {
  const enters = /* @__PURE__ */ new Set();
  const idles = /* @__PURE__ */ new Set();
  collectCues(resolveEventScene(name).nodes(), enters, idles);
  const scope = `.${className}`;
  const rules2 = [];
  for (const key2 of enters) {
    const { dur, easing } = EV_ENTER[key2];
    rules2.push(
      `@keyframes ${KEYFRAME_PREFIX}${key2}{${EV_WEB_ENTER_KEYFRAMES[key2]}}`,
      `${scope}.pl .e-${key2}{animation:${KEYFRAME_PREFIX}${key2} var(--d,${dur}ms) ${bezier(easing)} var(--t,0ms) both}`
    );
  }
  for (const key2 of idles) {
    const { duration, easing } = EV_IDLE[key2];
    rules2.push(
      `@keyframes ${KEYFRAME_PREFIX}${key2}{${EV_WEB_IDLE_KEYFRAMES[key2]}}`,
      `${scope}.id .i-${key2}{animation:${KEYFRAME_PREFIX}${key2} ${duration}ms ${bezier(easing)} var(--dl,0ms) infinite}`
    );
  }
  rules2.push(`@media (prefers-reduced-motion:reduce){${scope} *{animation:none!important}}`);
  return rules2.map((rule) => rule.replace(/\s+/g, " ").trim()).join("\n");
}

// src/photoFan/index.ts
var PHOTO_FAN = {
  /** The back tiles' tilt, in degrees, positive clockwise. Mirrored under RTL. */
  tiltDeg: 8,
  /** How far a back tile's centre sits from the front tile's, in tile edges. */
  spread: 0.35,
  /**
   * The share of the box the fan may fill on its tighter axis. The rest is room for
   * the tiles' shadow, which a clipping parent would otherwise cut off.
   */
  fill: 0.92,
  /** The white frame around each photo, in px on web and pt on native. */
  frameWidth: 3,
  /** A tile's corner radius, as a fraction of its edge. */
  radiusRatio: 0.1,
  /** Web only: how far the fan opens on hover, as a multiplier on each tile's offset. */
  hoverSpread: 1.08
};
var PHOTO_FAN_ASPECT = 1.5;
var SLOTS = [
  { x: -PHOTO_FAN.spread, rotate: -PHOTO_FAN.tiltDeg, imageIndex: 1 },
  { x: PHOTO_FAN.spread, rotate: PHOTO_FAN.tiltDeg, imageIndex: 2 },
  { x: 0, rotate: 0, imageIndex: 0 }
];
var halfExtent = (deg) => {
  const rad = Math.abs(deg) * Math.PI / 180;
  return (Math.cos(rad) + Math.sin(rad)) / 2;
};
function resolvePhotoFan(imageCount, boxWidth, boxHeight) {
  const count = Math.max(0, Math.min(Math.floor(imageCount), SLOTS.length));
  const hullHalfH = halfExtent(PHOTO_FAN.tiltDeg);
  const hullHalfW = PHOTO_FAN.spread + hullHalfH;
  const size = Math.min(
    boxWidth * PHOTO_FAN.fill / (2 * hullHalfW),
    boxHeight * PHOTO_FAN.fill / (2 * hullHalfH)
  );
  const slots = SLOTS.filter((slot) => slot.imageIndex < count);
  const left = Math.min(...slots.map((s) => s.x - halfExtent(s.rotate)));
  const right = Math.max(...slots.map((s) => s.x + halfExtent(s.rotate)));
  const shift = slots.length > 0 ? -(left + right) / 2 : 0;
  return {
    size,
    radius: size * PHOTO_FAN.radiusRatio,
    tiles: slots.map((slot) => {
      const dx = (slot.x + shift) * size;
      return {
        imageIndex: slot.imageIndex,
        left: boxWidth / 2 + dx - size / 2,
        top: (boxHeight - size) / 2,
        dx,
        rotate: slot.rotate
      };
    })
  };
}

// src/mapPin/index.ts
var MapPinTone = /* @__PURE__ */ ((MapPinTone2) => {
  MapPinTone2["Brand"] = "brand";
  MapPinTone2["Dark"] = "dark";
  return MapPinTone2;
})(MapPinTone || {});
var MAP_PIN = {
  width: 40,
  height: 52,
  viewBox: "0 0 40 52",
  /** A circle of radius 18 about (20, 20), tapering to a rounded tip. */
  body: "M20 2C10.06 2 2 10.06 2 20c0 11.6 12.9 22.3 16.7 27.2a1.65 1.65 0 0 0 2.6 0C25.1 42.3 38 31.6 38 20 38 10.06 29.94 2 20 2Z",
  strokeWidth: 2.5,
  /**
   * Painted UNDER the body. A drawn contact shadow rather than a platform one: an
   * Android marker is a rasterised snapshot that drops `elevation`, so this is the
   * only lift both clients render the same.
   */
  shadow: { cx: 20, cy: 48.4, rx: 6.5, ry: 2.2, opacity: 0.22 },
  /** The dark tone's centre dot. */
  dot: { cx: 20, cy: 20, r: 6 }
};
var MAP_PIN_ANCHOR = { x: 0.5, y: 48 / MAP_PIN.height };
var MAP_PIN_TONES = {
  ["brand" /* Brand */]: { fill: "#FF6A74", stroke: "#FFFFFF", inner: "#FFFFFF" },
  ["dark" /* Dark */]: { fill: "#1C1B1F", stroke: "#FFFFFF", inner: "#FFFFFF" }
};
var LOGO_MARK_VIEWBOX = "-76.238 -66.766 1164.039 1164.039";
var LOGO_MARK_PATH = "M382.365 234.683C318.676 240.814 254.405 269.198 224.406 324.895C223.362 305.113 222.318 285.33 221.274 265.548C220.893 258.327 220.23 250.428 215.195 245.237C207.799 237.612 195.291 239.711 185.007 242.373C143.99 252.992 102.972 263.612 61.954 274.231C46.517 278.228 26.943 289.411 32.472 304.368C35.294 312.001 43.705 315.688 49.754 321.131C63.299 333.319 64.479 353.787 64.67 372.006C65.713 471.664 65.991 571.33 65.505 670.993C65.395 693.365 64.655 717.538 50.927 735.203C44.273 743.764 34.842 750.333 30.31 760.183C12.545 798.794 82.137 789.426 98.933 789.569C139.166 789.911 179.399 790.253 219.632 790.595C231.088 790.693 243.145 790.643 253.127 785.021C263.109 779.398 269.769 766.142 264.21 756.125C259.318 747.312 247.9 744.877 240.037 738.571C227.037 728.145 225.654 709.214 225.33 692.554C224.308 640.048 223.287 587.542 222.265 535.036C221.468 494.09 220.77 452.369 232.466 413.12C244.162 373.871 270.464 336.772 308.879 322.576C328.171 315.448 350.19 314.607 369.118 322.652C393.984 333.221 410.736 357.748 418.492 383.629C426.249 409.509 426.275 436.985 426.237 464.003C426.137 536.356 426.037 608.709 425.937 681.062C425.91 700.72 425.027 722.568 411.193 736.534C400.923 746.902 383.407 753.879 383.62 768.47C383.861 785.01 405.969 790.076 422.511 790.061C479.187 790.007 535.862 789.953 592.537 789.899C610.099 789.883 634.05 783.337 632.262 765.866C630.722 750.814 611.027 746.366 600.444 735.553C590.198 725.084 589.138 708.962 588.705 694.319C586.574 622.129 585.129 549.876 587.504 477.694C588.363 451.592 589.819 425.018 598.956 400.553C613.402 361.876 647.641 331.202 687.668 321.08C702.997 317.203 719.495 316.254 734.426 321.457C756.442 329.128 772.259 349.341 780.244 371.245C788.23 393.149 789.49 416.85 790.415 440.145C793.578 519.747 793.766 599.467 790.98 679.082C790.343 697.298 789.154 716.694 778.419 731.423C772.449 739.614 763.94 745.694 758.008 753.912C752.076 762.13 749.308 774.245 755.781 782.044C761.511 788.948 771.71 789.533 780.682 789.569C838.358 789.801 896.035 790.034 953.711 790.266C963.796 790.307 974.326 790.246 983.302 785.65C992.279 781.055 999.019 770.392 995.714 760.864C991.746 749.428 977.165 746.435 968.016 738.508C956.132 728.21 954.528 710.657 953.889 694.945C951.151 627.585 950.509 560.14 951.967 492.74C952.891 450.024 954.613 406.805 945.602 365.04C936.591 323.275 915.366 282.318 879.557 259.011C853.599 242.115 822.092 235.739 791.167 234.036C748.96 231.713 705.801 237.687 667.481 255.531C629.161 273.375 595.978 303.666 578.549 342.176C565.628 302.292 535.588 268.276 497.608 250.521C467.754 236.566 434.072 232.578 401.131 233.514C394.904 233.691 388.637 234.079 382.365 234.683";
var MARK_INK = { x: 12.545, y: 231.713, width: 986.474, height: 567.081 };
var MARK_WIDTH = 21;
var markScale = MARK_WIDTH / MARK_INK.width;
var round = (n) => Number(n.toFixed(5));
var MAP_PIN_MARK_MATRIX = [
  round(markScale),
  0,
  0,
  round(markScale),
  round(20 - markScale * (MARK_INK.x + MARK_INK.width / 2)),
  round(20 - markScale * (MARK_INK.y + MARK_INK.height / 2))
];
var MAP_PIN_MARK_TRANSFORM = `matrix(${MAP_PIN_MARK_MATRIX.join(" ")})`;
export {
  BRAND_CORAL,
  EV_ALIASES,
  EV_BANNER_NAMES,
  EV_BOOT_NAMES,
  EV_CHAT_NAMES,
  EV_EASING,
  EV_ENTER,
  EV_FERRY_STAGGER,
  EV_ICON_NAMES,
  EV_IDLE,
  EV_IDLE_STAGGER,
  EV_MUTED_OPACITY,
  EV_NAV_NAMES,
  EV_PALETTE,
  EV_PLAY_TAIL,
  EV_SCENES,
  EV_STATUS_NAMES,
  EV_WEB_ENTER_KEYFRAMES,
  EV_WEB_IDLE_KEYFRAMES,
  ILL_BLOB_D,
  ILL_EASING,
  ILL_ENTER,
  ILL_KEYFRAME,
  ILL_MOTION,
  ILL_PAGE_DUR,
  ILL_PAGE_NAMES,
  ILL_PAGE_SCENES,
  ILL_PAGE_TEXT,
  ILL_PALETTE,
  ILL_SCENES,
  ILL_VIEW_BOX,
  LOGO_MARK_PATH,
  LOGO_MARK_VIEWBOX,
  MAP_PIN,
  MAP_PIN_ANCHOR,
  MAP_PIN_MARK_MATRIX,
  MAP_PIN_MARK_TRANSFORM,
  MAP_PIN_TONES,
  MapPinTone,
  PAGE_SUBJECT_ZONE,
  PAGE_VIEW_BOX,
  PHOTO_FAN,
  PHOTO_FAN_ASPECT,
  WORDMARK,
  bar,
  cup,
  evSceneAspect,
  evSceneEnd,
  eventSceneStaticCss,
  eventSceneToStaticSvg,
  frame,
  idleDelay,
  logoLarge,
  logoSmall,
  pencil,
  plant,
  resolveEventName,
  resolveEventScene,
  resolvePhotoFan,
  star
};
